import * as ng from 'angular';
import * as _ from 'lodash-es';

import {Utils} from '@amzn/aws-workdocs-web-client-common';
import {DocMetadata} from "../types/DocMetadata";
import {RootScope} from "../types/angular-types";
import TasksService from "../tasks/TasksService";
import Features from "../feature-manager/Features";
import {IModalFactory} from "../shared/ModalFactory";
import {FolderMetadata} from "../types/FolderMetadata";
import SignalProvider from "../gorillaboy/SignalProvider";
import AppConstants from "../gorillaboy/AppConstants";
import {ApprovalDetailsService} from "../approvals/approvals-types";

export interface IScope extends ng.IScope {
    fileManagerInstance: any;
}

    angular.module('GorillaBoy.FileBrowser')
    .controller('FileBrowserController', [
        '$scope',
        '$window',
        '$routeParams',
        '$log',
        '$timeout',
        '$location',
        '$filter',
        '$q',
        '$sce',
        '$rootScope',
        '$translate',
        '$uibModal',
        'DocumentService',
        'DocumentStateService',
        'GetNextDocumentService',
        'ResourceService',
        'GroupService',
        'UserCollectionService',
        'FeatureManagerService',
        'FileService',
        'FileManagerFactory',
        'OrganizationService',
        'SessionManager',
        'PathManager',
        'LayoutManager',
        'ContentTypeFormatter',
        'View',
        'MessageManager',
        'MessageProvider',
        'FileCountService',
        'FileService',
        'SortService',
        'userInfo',
        'localStorageService',
        'ClientMetricsService',
        'PromiseWatcherService',
        'MetricEvents',
        'SystemTags',
        'UIEvents',
        'FileBrowserControllerUpload',
        'CheckinCheckoutController',
        'BaseFileBrowserController',
        'DocumentDropdownController',
        'CompanionService',
        'ModalFactory',
        'FeedbackService',
        'FavoritesService',
        'Favorites',
        'BrowserService',
        'FileUploadService',
        'RegionService',
        'AuthService',
        'TokenService',
        'EndpointService',
        'UserRecoveryBinInfo',
        'TasksService',
        'ApprovalDetailsService',
        'DocumentUtilities',
        FileBrowserController
    ]);

    function FileBrowserController($scope : IScope, $window : ng.IWindowService, $routeParams, $log : ng.ILogService, $timeout : ng.ITimeoutService,
        $location : ng.ILocationService, $filter : ng.IFilterService, $q : ng.IQService, $sce : ng.ISCEService, $rootScope : RootScope,
        $translate, $uibModal, DocumentService, DocumentStateService, GetNextDocumentService, ResourceService, GroupService,
        UserCollectionService, FeatureManagerService, fileService, FileManagerFactory, OrganizationService, SessionManager,
        PathManager, LayoutManager, ContentTypeFormatter, View, MessageManager, MessageProvider,
        FileCountService, FileService, SortService,
        userInfo, localStorageService,
        ClientMetricsService, PromiseWatcherService, MetricEvents, SystemTags, UIEvents, FileBrowserControllerUpload, CheckinCheckoutController, BaseFileBrowserController, DocumentDropdownController, CompanionService,
        ModalFactory : IModalFactory, FeedbackService, FavoritesService, Favorites, BrowserService, FileUploadService, RegionService, AuthService,
        TokenService, EndpointService, UserRecoveryBinInfo, TasksService : TasksService, ApprovalDetailsService: ApprovalDetailsService, DocumentUtilities) {

        var TYPE_FOLDER = 'FOLDER',
            TYPE_DOCUMENT = 'DOCUMENT',
            BACKOFF_THRESHOLD = 60 * 1000,
            ANONYMOUS_ID = AppConstants.CollaboratorTypes.ANONYMOUS.toLowerCase(),
            // AppConstant bindings
            globalRoles = AppConstants.GlobalRoles,
            galleryTypes = AppConstants.GalleryTypes,
            viewTypes = AppConstants.ViewTypes,
            skuTypes = AppConstants.SkuType,
            rightTabTypes = AppConstants.RightTabTypes,
            permissions = AppConstants.Permissions,
            OSTypes = AppConstants.OSTypes,

            //The percentage of distance between thumbs bottom edge and scrollable bottom edge
            //So when user scrolls the page so that there's less than 25% of space between bottom edges of thumb and scrollable, trigger pageload

            downloadMetadataAttempts = {},

            // all modal instances.
            createFolderModal = null,
            createNoteModal = null,
            deleteFolderModal = null,
            bulkDeleteModal = null,
            emptyRecycleBinModal = null,
            removePermissionConfirmModal = null,

            moveIntoSharedModal = null,
            selectRecoveryBinModal = null,
            recoverIntoMyDocsModal = null,
            shareModal = null,
            transferModal = null,
            newUserTourModal= null;



        // Set user context on the FileManagerFactory so we can simplify operations going forward.
        FileManagerFactory.setUserContext(userInfo);
        var fileManager = new FileManagerFactory.FileManager();
        $scope.$on("$destroy", function() {
            fileManager.destroy();
        });

        $scope.fileManagerInstance = fileManager;

        BaseFileBrowserController.initScope($scope, View, userInfo);
        CheckinCheckoutController.initScope($scope, userInfo);
        FileBrowserControllerUpload.initScope($scope);
        DocumentDropdownController.initScope($scope, userInfo);
        activate();



        $scope.showNewFileDropdownMenu = false;
        $scope.toggleNewFileDropdownMenu = function() {
            $scope.showNewFileDropdownMenu = !$scope.showNewFileDropdownMenu;
        };
        /**
         * Main function that gets invoked when this controller is activated.
         */
        function activate() {

            //Cancel all pending requests of feedback
            $rootScope.$emit(SignalProvider.Feedback.Cancel);
            // Start the folder load metric event.
            ClientMetricsService.startLatencyEvent(MetricEvents[View]);

            $log.debug(new Date().toISOString() + ' [FileBrowserController] Initiating…');

            // Reset DocumentStateService because we may be coming from a document page.
            DocumentStateService.resetDocumentState();

            if (View === viewTypes.RECOVERY_TYPE && FeatureManagerService.isFeatureEnabled(Features.UI.RECOVERY_FOLDER) && UserRecoveryBinInfo) {
                var userRecoveryFolderId = UserRecoveryBinInfo.RecoveryFolderId;

                if (userRecoveryFolderId) {
                  fileManager.setCurrentFolder(userRecoveryFolderId);
                  fileManager.setRecoveryFolder(userRecoveryFolderId);
                } else {
                  // We need to set null, otherwise it can be treated as UNDEFINED.
                  fileManager.setRecoveryFolder(null);
                }
                setRecoveryBinUserLabel(UserRecoveryBinInfo);

            } else {
                fileManager.setCurrentFolder($routeParams.folderId, View);
                setRecoveryBinUserLabel(userInfo);
            }

            if (View !== viewTypes.SHARED_TYPE) {
                $rootScope.preFetchSharedWithMeDebounced();
            }

            var params = [userInfo.RootFolderId, userInfo.RecycleBinFolderId],
                types = [viewTypes.OWN_TYPE, viewTypes.RECYCLE_TYPE];

            if (params.indexOf($routeParams.folderId) !== -1 || types.indexOf(View) !== -1) {
                SessionManager.clearHistory();
            }

            if (View !== viewTypes.FOLDER_TYPE && View !== viewTypes.OWN_TYPE && View !== viewTypes.RECYCLE_TYPE && View !== viewTypes.RECOVERY_TYPE) {
                SessionManager.setCurrentView(View);
            }

            var partialContentResult = './file-browser/content_partial.html',
                ONLINE_EDITOR_IFRAME_ELEMENT_ID = "online_editor_iframe";

            if (ApprovalDetailsService.isPanelVisiable()) {
                $timeout(function() {
                    $rootScope.$broadcast(SignalProvider.Sidebar.ShowRight, AppConstants.RightTabTypes.NEW_APPROVAL_REQUEST_TAB);
                });
            }

            // SECTION: Layout code
            $scope.layout = {
                partialContent: partialContentResult,
                partialModals: './file-browser/modals.html',
                partialTitleBar: './file-browser/title_bar.html',
                partialSidebarPeople: './file-browser/sidebar_people.html',
                partialSidebarSecurity: './file-browser/sidebar_security.html',
                partialSidebarFeedbackInput: '',
                view: View,
                //Master copy of whether left sidebar should be shown/hidden.
                showLeftSidebar: $rootScope.showLeftSidebar,
                hasRightSidebar: true,
                showRightSidebar: false,
                showUploadPane: false
            };

            // SECTION: Modals variables
            $scope.modals = {
                folderName: '',
                noteName: ''
            };

            // SECTION: load more
            /*
             * contentLoadingPromise is a promise set when there is new content (folder or file) adding to the current model
             * For example, openning a new file browser, loading paginated data, and sort all involve synchronizing data from
             * file manager to the current model. contentLoadingPromise is set when the process start, resolves when the process
             * complete, and MOST IMPORTANTLY set to null when the process finishes. Remember to set it to null after it finishes
             * because it also serves as a flag of whether or not there is a loading process going on.
             */
            $scope.contentLoadingPromise = null;

            // SECTION: Folder Controller State variables
            $scope.folderState = {
                accessRequestText : '',
                checkinCheckoutEnabled : FeatureManagerService.isFeatureEnabled(Features.UI.CHECKIN_CHECKOUT),
                folderErrorCode: 0,
                view: View,
                viewType: SessionManager.getPreferred(),
                activeFolderId: $routeParams.folderId,
                activeFolderOwnerUsername: null,
                activeParentFolderId: null,
                loaded: false,
                deepInSharedFolder: false,
                inRecycle: $routeParams.folderId === userInfo.RecycleBinFolderId || View === viewTypes.RECYCLE_TYPE,
                inOwnFolder: $routeParams.folderId === userInfo.RootFolderId || View === viewTypes.OWN_TYPE,
                inRecovery: View === viewTypes.RECOVERY_TYPE,
                hideOwnerCaption: !(View === viewTypes.SHARED_TYPE || View === viewTypes.AWAITING_FEEDBACK_TYPE),
                itemsSelected: false,
                itemsSelectedCount: 0,
                emptyMessage: null,
                defaultEmptyMessage: MessageProvider.emptyMessageDocsGallery,
                selectedAll: false,
                principals: null,
                showSharedFolderPermission: false
            };

            $scope.resourceInfo = {
                viewType: $scope.layout.view,
                Id: $scope.folderState.activeFolderId
            };

            $scope.RoleTypes = AppConstants.RoleTypes;

            $scope.noteState = {
                noteErrorText: ''
            };

            $scope.sharedByMeCategory = {
            	ALL: null,
            	SHARED_WITH_ME : 'SHARED_WITH_ME',
            	SHAREABLE_LINK : 'SHAREABLE_LINK',
            	ANONYMOUS_LINK : 'ANONYMOUS_LINK'
            };

            $scope.currentSharedByMeFilter = {
            	startTime: null,
            	endTime: null,
            	resourceCategory: null
            };

            // SECTION: Single file action variables
            // Top action bar variables
            $scope.resourcePermissionsMap = {};
            $scope.userActionsMap = {};
            $scope.actionBar = {
                showMoreOptions : false,
                canOpenContainingFolder: (View === viewTypes.FAVORITES),
                canOpen: true,
                canEdit: false,
                canEditOnline: false,
                canShare: false,
                canShareLink: false,

                canCheckout: false,
                canDiscardCheckout: false,
                canCheckin : false,

                canDelete: false,
                canMove: false,
                canDownload: false,
                canUpload: false,
                canRequestCheckin: false,
                canRename: false,
                canRemoveFromShare: false,
                resourceType: null
            };

            // Store the currentUserRoles for the selected file
            $scope.currentUserRoles = [];

            $scope.sidebar = {
                selectedIndex: 0,
                tabName: 'People',
                tabs: ['People', AppConstants.RightTabTypes.NEW_APPROVAL_REQUEST_TAB, 'Security']
            };

            $scope.metadata = {};
            $scope.documents = [];
            $scope.folders = [];
            $scope.selectedFileCount = 0;
            $scope.newDocOrFolderName = {};
            $scope.userInfo = userInfo;
            $scope.organizationId = userInfo.OrganizationId;
            $scope.GalleryTypes = galleryTypes;
            $scope.ViewTypes = viewTypes;
            $scope.SkuTypes = skuTypes;
            $scope.RightTabTypes = rightTabTypes;
            $scope.SortOrder = SortService.CONSTANTS.ORDER;
            $scope.isBasicUser = (userInfo.SkuType === $scope.SkuTypes.BASIC) ? true : false;
            $scope.pagination = {
                marker: null
            };

            // Anonymous feature is enabled
            $scope.isAnonymousSharingEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.ANONYMOUS_LINK);

            // SECTION: sort
            $scope.sortOption = SortService.getSortOption($scope.folderState.view, $scope.folderState.viewType);
            $scope.sortOrder = $scope.sortOption.order;
            fileManager.setSortOptions($scope.sortOption.sortBy, $scope.sortOption.order);
            // We set the view type in SortService so we can tell what the most recent view is through SortService.
            // This is useful for features like prev/next doc in the document view if we need to figure out which sort
            // options to use from those in localStorage and we don't have as much context as we would in a list view.
            SortService.setType($scope.folderState.view);

            if (FeatureManagerService.isFeatureEnabled(Features.DocumentViewer.ONLINEEDITING)) {
                OrganizationService.getFeatureDetails(AppConstants.ORG_FEATURES.ONLINE_EDITING).then(function(data) {
                    if (angular.equals(data, {})) {
                        return;
                    }
                    $rootScope.onlineEditingEnabled = data.Enabled;
                }, function(response) {
                    $rootScope.onlineEditingEnabled = false;
                });
            }

            function successRequestAccess(response) {
                $scope.userRequestedForThisFolderAlready = true;
                removePermissionConfirmModal = $uibModal.open({
                    templateUrl: 'accessRequestSuccessMessage.html'
                });
                $scope.folderState.accessRequestText = '';
                DocumentService.setResourceAsRequested($routeParams.folderId);
            }

            function errorRequestAccess(response) {
                removePermissionConfirmModal = $uibModal.open({
                    templateUrl: 'accessRequestErrorMessage.html'
                });
            }

            $scope.submitAccessRequest = function() {
                if ($scope.userRequestedForThisFolderAlready) {
                    return;
                }

                if (FeatureManagerService.isFeatureEnabled(Features.UI.SHOW_TASKS)) {
                    TasksService.createTask(null, null, $routeParams.folderId, AppConstants.TASKDEF_IDS.REQUEST_ACCESS)
                    .then(successRequestAccess, errorRequestAccess);
                }  else {
                    //TODO: Call the backend service to send this request and display an alert
                    DocumentService.submitAccessRequest($routeParams.folderId, $scope.folderState.accessRequestText)
                    .then(successRequestAccess, errorRequestAccess);
                }
            };
            $scope.userRequestedForThisFolderAlready = DocumentService.didUserRequestForThisResourceAlready($routeParams.folderId);
            // Verify there isn't an existing task to request access
            if(!$scope.userRequestedForThisFolderAlready && FeatureManagerService.isFeatureEnabled(Features.UI.SHOW_TASKS)) {
                TasksService.getTasks($routeParams.folderId, null, null, null)
                .then(function(response){
                    $scope.userRequestedForThisFolderAlready = (response.Tasks.length > 0);
                }, function(response){
                    $log.error(response);
                });
            }

            $scope.showRequestAccessButton = function() {
                return $scope.folderState.folderErrorCode === AppConstants.HttpStatuses.NOT_FOUND ||
                    $scope.folderState.folderErrorCode === AppConstants.HttpStatuses.FORBIDDEN;
            };

            $scope.showFolder = function(folderId) {
                if (folderId === userInfo.RootFolderId) {
                    $rootScope.showDocs();
                } else if (folderId === userInfo.RecycleBinFolderId) {
                    $rootScope.showRecycle();
                } else {
                    $rootScope.showFolder(folderId, false, false);
                }
            };

            $scope.updateLastActiveNoteEditUrl = function() {
                if (userInfo.NoteInfo && userInfo.NoteInfo.LastActiveNoteId !== null) {
                    DocumentService.getDocument(userInfo.NoteInfo.LastActiveNoteId)
                    .then(function(response) {
                    var data = response.data.Metadata;
                    $scope.constructOnlineEditorUrl(data).then(function(onlineEditingUrl) {
                        if (document.getElementById(ONLINE_EDITOR_IFRAME_ELEMENT_ID) !== null) {
                            (document.getElementById(ONLINE_EDITOR_IFRAME_ELEMENT_ID) as any).src = onlineEditingUrl;
                        }
                    });
                    });
                }
            };

            $scope.noteOnlineEditingUrl =  $scope.updateLastActiveNoteEditUrl();

            $scope.isCurrentFolderFavorite = function() {
                var folderId = fileManager.getCurrentFolder();
                if (!folderId) {
                    return;
                }
                return Favorites.Folders.indexOf(folderId) !== -1;
            };

            $scope.toggleFavoriteCurrentFolder = function() {
                var folderId = fileManager.getCurrentFolder();
                if (!folderId) {
                    return;
                }
                var isFav = $scope.isCurrentFolderFavorite();
                if (!isFav) {
                    doLocalFav(true);
                    FavoritesService.createFav(folderId, AppConstants.FolderContentTypes.FOLDER)
                    .then(null, restoreValue);
                } else {
                    doLocalFav(false);
                    FavoritesService.deleteFav(folderId, AppConstants.FolderContentTypes.FOLDER)
                    .then(null, restoreValue);
                }

                function restoreValue(response) {
                    MessageManager.addErrorMessage($translate.instant('FAVORITES.SAVE_FAILURE'));
                    //When the request is not successful remove the folderId from the list
                    doLocalFav(isFav);
                }

                function doLocalFav(isFav) {
                    if (isFav) {
                        Favorites.Folders.push(folderId);
                    } else {
                        Favorites.Folders = Favorites.Folders.filter(function(id) {
                            return id !== folderId;
                        });
                    }
                }
            };

            $scope.goToParent = function(id) {
                var showMyDocs = false,
                    showRecycleBin = false;
                if (userInfo.RootFolderId === id) {
                    showMyDocs = true;
                }
                if (userInfo.RecycleBinFolderId === id) {
                    showRecycleBin = true;
                }
                LayoutManager.goToParent(id, showMyDocs, showRecycleBin);
            };

            $scope.showMoveOptionForCurrentFolder = function() {
                if (fileManager.isInTrash() || $scope.inOwn() || fileManager.isInNoteRoot()) {
                    return false;
                }
                // Only owners can move documents or folders
                if (getOwnerId($scope.metadata) === getUserId()) {
                    return true;
                } else {
                    return fileManager.hasRightForFolder(permissions.MOVE);
                }
            };

            $scope.showRenameOptionForCurrentFolder = function() {
                return !$scope.inOwn() && !fileManager.isInNoteRoot() && fileManager.hasRightForFolder(permissions.RENAME);
            };
            /*
             * The below methods contain logic to determine Permissions inside folder.
             */
            $scope.showDeleteOptionForCurrentFolder = function() {
                // Delete Folder option is not supported in the Recycle Bin
                if (fileManager.isInTrash() || $scope.inOwn() || fileManager.isInNoteRoot()) {
                    return false;
                }

                return fileManager.hasRightForFolder(permissions.DELETE);
            };

            $scope.showRemoveUserFromShareOptionForCurrentFolder = function() {
                return !fileManager.isInTrash() && fileManager.hasRightForFolder(permissions.REMOVE_FORM_SHARE);
            };

            $scope.showFavoriteForCurrentFolder = function() {
                return !userInfo.MinimalUser && $scope.folderState.view === viewTypes.FOLDER_TYPE;
            };

            /**
             * This method will be used to check if the Remove Me From Share option should be disabled or not.
             * The logic checks if the user is not the owner of the file and there's no permission to do the operation.
             */
            $scope.removeUserFromShareOptionForCurrentFolderDisabled = function() {
                return getOwnerId($scope.metadata) !== userInfo.Id && !$scope.showRemoveUserFromShareOptionForCurrentFolder() && !fileManager.isInSharedByMe();
            };

            $scope.hasSharePermission = function() {
                if (fileManager.isInTrash()) {
                    return false;
                }
                // Only owners and coowners can share documents/folders.
                if (fileManager.hasRightForFolder(permissions.SHARE)) {
                    return true;
                }
                return false;
            };

            $scope.hasShareLinkPermission = function() {
                // currently, user has share a link permission if user has share permission
                return $scope.isAnonymousSharingEnabled && $scope.hasSharePermission();
            };

            $scope.hasUploadPermission = function() {
                return !fileManager.isInTrash() && View !== AppConstants.LayoutViewTypes.VIEW_FAVORITES_LAYOUT &&
                    ($scope.folderState.view !== viewTypes.SHARED_TYPE) &&
                    ($scope.folderState.view !== viewTypes.AWAITING_FEEDBACK_TYPE) &&
                    ($scope.folderState.view !== viewTypes.OUT_FOR_REVIEW_TYPE) &&
                    fileManager.hasRightForFolder(permissions.UPLOAD);
            };

            $scope.hasCreateFolderPermission = function() {
                return !fileManager.isInTrash() && View !== AppConstants.LayoutViewTypes.VIEW_FAVORITES_LAYOUT &&
                    ($scope.folderState.view !== viewTypes.SHARED_TYPE) &&
                    ($scope.folderState.view !== viewTypes.AWAITING_FEEDBACK_TYPE) &&
                    ($scope.folderState.view !== viewTypes.OUT_FOR_REVIEW_TYPE) &&
                    fileManager.hasRightForFolder(permissions.CONTRIBUTE);
            };

            $scope.deleteUpperLimitBreached = function() {
                // The upper cap is a temporary solution to the fact that service can only process 20 delete requests
                // at the same time
                return fileManager.getTotalSelectedItemCount() > AppConstants.LIMITS.CONCURRENT_OPERATION;
            };

            $scope.deleteSupported = function() {
                return fileManager.getTotalSelectedItemCount() > 0 && !$scope.deleteUpperLimitBreached();
            };

            $scope.downloadSupported = function() {
                // Currently we cannot download more than one file at a time.
                // This will change once we offer on-the-fly zipping.
                return fileManager.getTotalSelectedItemCount() === 1 && fileManager.getSelectedFolderCount() === 0;
            };

            $scope.editSupported = function() {
                return fileManager.getTotalSelectedItemCount() === 1 && fileManager.getSelectedFolderCount() === 0 && !$scope.isBasicUser;
            };

            $scope.shareSupported = function() {
                // Currently we cannot share more than one file/folder at a time (has to be done through folder sharing)
                return fileManager.getTotalSelectedItemCount() === 1;
            };

            $scope.removeFromShareSupported = function() {
                return fileManager.getTotalSelectedItemCount() === 1;
            };

            $scope.checkoutSupported = function() {
                return (fileManager.getSelectedDocCount() === 1) && !$scope.isBasicUser;
            };

            $scope.renameSupported = function() {
                return fileManager.getTotalSelectedItemCount() === 1;
            };

            $scope.moveSupported = function() {
                return fileManager.getTotalSelectedItemCount() === 1;
            };

            $scope.canDeclineFeedback = function() {
                // decline feedback is only supported in "Awaiting Feedback"
                return $scope.inFeedback();
            };

            $scope.declineFeedbackSupported = function() {
                return fileManager.getSelectedDocCount() === 1;
            };

            // lazy loading single file actions
            $scope.getUserRightsForResource = function(resourceId, resourceType) {
                resourceType = (resourceType === 'file' || resourceType === TYPE_DOCUMENT) ? TYPE_DOCUMENT : TYPE_FOLDER;
                $scope.actionBar.resourceType = resourceType;

                var generalPermissionPromise = $q.defer(),
                    commentsLockedPromise = $q.defer(),
                    checkinCheckoutPromise = $q.defer();

                if ($scope.userActionsMap[resourceId]) {
                    updateTopActionBar();
                    generalPermissionPromise.resolve();
                    commentsLockedPromise.resolve();
                    checkinCheckoutPromise.resolve();
                } else {
                    var docOrFolder = null;
                    if(resourceId === $scope.metadata.Id) {
                        docOrFolder = $scope.metadata;
                    } else {
                        docOrFolder = $scope.__getFileById(resourceType, resourceId);
                    }

                    $scope.userActionsMap[resourceId] = {};
                    $scope.resourcePermissionsMap[resourceId] = {};

                    // owners always have following user rights.
                    if (getOwnerId(docOrFolder) === getUserId()) {
                        $scope.userActionsMap[resourceId].canEdit = resourceType === TYPE_DOCUMENT ? canEdit(docOrFolder) : false;
                        $scope.userActionsMap[resourceId].canEditOnline = resourceType === TYPE_DOCUMENT ? canEditOnline(docOrFolder) : false;
                        $scope.userActionsMap[resourceId].editOnlineDisableMessage = resourceType === TYPE_DOCUMENT ? getEditOnlineDisableMessage(docOrFolder) : false;
                        $scope.userActionsMap[resourceId].canShare = canShare(docOrFolder, resourceType);
                        $scope.userActionsMap[resourceId].canShareLink = canShareLink(docOrFolder, resourceType);
                        $scope.userActionsMap[resourceId].canCheckout = resourceType === TYPE_DOCUMENT ? canCheckout(docOrFolder) : false;
                        $scope.userActionsMap[resourceId].canDelete = canDelete(docOrFolder);
                        $scope.userActionsMap[resourceId].canMove = canMove(docOrFolder);
                        $scope.userActionsMap[resourceId].canDownload = resourceType === TYPE_DOCUMENT ? canDownload(docOrFolder) : false;
                        $scope.userActionsMap[resourceId].canUpload = resourceType === TYPE_DOCUMENT ? canUpload(docOrFolder) : false;
                        $scope.userActionsMap[resourceId].canRequestCheckin = resourceType === TYPE_DOCUMENT ? canRequestCheckin(docOrFolder) : false;
                        $scope.userActionsMap[resourceId].canRename = canRename(docOrFolder);
                        $scope.userActionsMap[resourceId].canEditWithO365 = resourceType === TYPE_DOCUMENT ? canEditWithO365(docOrFolder) : false;
                        $scope.userActionsMap[resourceId].isOfficeLegacyFile = resourceType === TYPE_DOCUMENT ? $scope.isOfficeLegacyFile(docOrFolder) : false;

                        $scope.currentUserRoles = [{
                            role: AppConstants.GlobalRoles.OWNER,
                            roleType: AppConstants.RoleTypes.DIRECT,
                            principalType: AppConstants.PrincipalTypes.USER
                        }];
                        
                        updateTopActionBar();
                        if (resourceType === TYPE_DOCUMENT) {
                            ResourceService.describeResourcePermissions(resourceId)
                            .then(function(response) {
                                var data = response.data;
                                $scope.userActionsMap[resourceId].Attributes = data.Attributes;
                                generalPermissionPromise.resolve();
                            }, generalPermissionPromise.reject);
                        } else {
                            generalPermissionPromise.resolve();
                        }
                    } else {
                        ResourceService.describeResourcePermissions(resourceId)
                        .success(function(response) {
                            $scope.currentUserRoles = ResourceService.getCurrentUserRoles(response, userInfo, false);
                            $scope.resourcePermissionsMap[resourceId] = ResourceService.processUserRightsFromRoles($scope.currentUserRoles);
                            $scope.userActionsMap[resourceId].Attributes = response.Attributes;
                            if (!response.Attributes.DOWNLOAD || response.Attributes.DOWNLOAD === 'ALLOWED') {
                                $scope.resourcePermissionsMap[resourceId].add(permissions.DOWNLOAD);
                            }

                            // Currently we don't support remove me from group share.
                            angular.forEach(response.Principals, function(principal) {
                                if (getOwnerId(docOrFolder) !== userInfo.Id && principal.Id === userInfo.Id) {
                                    $scope.resourcePermissionsMap[resourceId].add(permissions.REMOVE_FORM_SHARE);
                                }
                            });
                            $scope.userActionsMap[resourceId].canCheckout = resourceType === TYPE_DOCUMENT ? canCheckout(docOrFolder, $scope.resourcePermissionsMap[resourceId]) : false;
                            $scope.userActionsMap[resourceId].canEdit = resourceType === TYPE_DOCUMENT ? canEdit(docOrFolder, $scope.resourcePermissionsMap[resourceId]) : false;
                            $scope.userActionsMap[resourceId].canEditOnline = resourceType === TYPE_DOCUMENT ? canEditOnline(docOrFolder, $scope.resourcePermissionsMap[resourceId]) : false;
                            $scope.userActionsMap[resourceId].editOnlineDisableMessage = resourceType === TYPE_DOCUMENT ? getEditOnlineDisableMessage(docOrFolder, $scope.resourcePermissionsMap[resourceId]) : false;
                            $scope.userActionsMap[resourceId].canShare = canShare(docOrFolder, resourceType, $scope.resourcePermissionsMap[resourceId]);
                            $scope.userActionsMap[resourceId].canShareLink = canShareLink(docOrFolder, resourceType, $scope.resourcePermissionsMap[resourceId]);
                            $scope.userActionsMap[resourceId].canDelete = canDelete(docOrFolder, $scope.resourcePermissionsMap[resourceId]);
                            $scope.userActionsMap[resourceId].canMove = canMove(docOrFolder, $scope.resourcePermissionsMap[resourceId]);
                            $scope.userActionsMap[resourceId].canDownload = resourceType === TYPE_DOCUMENT ? canDownload(docOrFolder, $scope.resourcePermissionsMap[resourceId]) : false;
                            $scope.userActionsMap[resourceId].canUpload = resourceType === TYPE_DOCUMENT ? canUpload(docOrFolder, $scope.resourcePermissionsMap[resourceId]) : false;
                            $scope.userActionsMap[resourceId].canRequestCheckin = resourceType === TYPE_DOCUMENT ? canRequestCheckin(docOrFolder, $scope.resourcePermissionsMap[resourceId]) : false;
                            $scope.userActionsMap[resourceId].canRename = canRename(docOrFolder, $scope.resourcePermissionsMap[resourceId]);
                            $scope.userActionsMap[resourceId].canRemoveFromShare = canRemoveFromShare(docOrFolder, $scope.resourcePermissionsMap[resourceId]);
                            $scope.userActionsMap[resourceId].canEditWithO365 = resourceType === TYPE_DOCUMENT ? canEditWithO365(docOrFolder, $scope.resourcePermissionsMap[resourceId]) : false;
                            $scope.userActionsMap[resourceId].isOfficeLegacyFile = resourceType === TYPE_DOCUMENT ? $scope.isOfficeLegacyFile(docOrFolder) : false;

                            updateTopActionBar();
                            generalPermissionPromise.resolve();
                        })
                        .error(generalPermissionPromise.reject);
                    }
                    if (resourceType === TYPE_DOCUMENT && !$scope.inRecovery()) {
                        DocumentService.getDocument(resourceId).then(function(response) {
                            var data = response.data;
                            if (data.Metadata.CommentsLocked === 'true') {
                                $scope.userActionsMap[resourceId].CommentsLocked = true;
                            } else {
                                $scope.userActionsMap[resourceId].CommentsLocked = false;
                            }
                            commentsLockedPromise.resolve();
                        }, commentsLockedPromise.reject);
                    } else {
                        commentsLockedPromise.resolve();
                    }
                    if (docOrFolder.CheckoutInfo && !$scope.inRecovery()) {
                        $scope.checkCheckinPermissions(resourceId).then(function() {
                            updateTopActionBar();
                            checkinCheckoutPromise.resolve();
                        }, checkinCheckoutPromise.reject);
                    } else {
                        checkinCheckoutPromise.resolve();
                    }
                }
                return $q.all({
                    generalPermissionPromise: generalPermissionPromise.promise,
                    commentsLockedPromise: commentsLockedPromise.promise,
                    checkinCheckoutPromise: checkinCheckoutPromise.promise,
                });
            };

            $scope.toggleDownloads = function(resourceId) {
                ClientMetricsService.addLogsToSession({
                    event: UIEvents.FILE_BROWSER.DROPDOWN_MENU_CLICKS.TOGGLE_DOWNLOADS,
                    metadata: getUserId(),
                });
                var newAllowDownloadPermission = $scope.userActionsMap[resourceId].Attributes.DOWNLOAD === 'DISALLOWED';
                DocumentService.updateDocumentPermissions(resourceId, newAllowDownloadPermission)
                .then(function (data) {
                    if (!!newAllowDownloadPermission) {
                        MessageManager.addSuccessMessage(MessageProvider.preventDownloadDisableSuccess);
                        $scope.userActionsMap[resourceId].Attributes.DOWNLOAD = 'ALLOWED';
                    } else {
                        MessageManager.addSuccessMessage(MessageProvider.preventDownloadEnableSuccess);
                        $scope.userActionsMap[resourceId].Attributes.DOWNLOAD = 'DISALLOWED';
                    }
                }, function (data){
                    MessageManager.addErrorMessage(MessageProvider.preventDownloadFailure);
                });
            };

            $scope.toggleFeedback = function(resourceId) {
                ClientMetricsService.addLogsToSession({
                    event: UIEvents.FILE_BROWSER.DROPDOWN_MENU_CLICKS.TOGGLE_FEEDBACK,
                    metadata: getUserId(),
                });
                var newCommentsLocked = !$scope.userActionsMap[resourceId].CommentsLocked;
                FeedbackService.disableFeedbackForDocument(resourceId, newCommentsLocked)
                .then(function() {
                    $scope.userActionsMap[resourceId].CommentsLocked = newCommentsLocked;
                    var langKey = newCommentsLocked ? 'MESSAGES.DOCUMENT_DISABLE_FEEDBACK_SUCCESS' : 'MESSAGES.DOCUMENT_ENABLE_FEEDBACK_SUCCESS';
                    MessageManager.addSuccessMessage($translate.instant(langKey));
                }, function disableFeedbackChangedFailure() {
                    MessageManager.addTransientErrorMessage(MessageProvider.documentDisableFeedbackFailure);
                });
            };

            $scope.checkCheckinPermissions = function(resourceId) {
                var doc = $scope.__getFileById(TYPE_DOCUMENT, resourceId);
                var deferred = $q.defer();

                //If you have a value that's other than NULL, use it!
                if ($scope.userActionsMap[resourceId] && $scope.userActionsMap[resourceId].canCheckin !== undefined &&
                    $scope.userActionsMap[resourceId].canDiscardCheckout !== undefined) {
                    return $q.when();
                }

                DocumentService.getDocument(resourceId, true).then(function(response) {
                    var data = response.data;
                    if (doc.CheckoutInfo && doc.CheckoutInfo.CheckoutUserId === getUserId() &&
                        //Either the LockType has to equal 'USER' or it shouldn't be defined at all
                        ( !doc.CheckoutInfo.LockType || doc.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.USER ) ) {
                        $scope.userActionsMap[resourceId].canCheckin = true;
                    } else {
                        $scope.userActionsMap[resourceId].canCheckin = false;
                    }
                    if (doc.CheckoutInfo && ( !doc.CheckoutInfo.LockType || doc.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.USER ) &&
                        getOwnerId(doc) === getUserId()) {
                        $scope.userActionsMap[resourceId].canForceCheckin = true;
                    } else {
                        $scope.userActionsMap[resourceId].canForceCheckin = false;
                    }
                    
                    DocumentService.describeAllDocumentVersions(resourceId, true).then(function (response) {
                        var docVersions = response.data.DocumentVersions;
                        $scope.userActionsMap[resourceId].canDiscardCheckout = canDiscardCheckout(data, docVersions, $scope.resourcePermissionsMap[resourceId]);
                        deferred.resolve();
                    });
                }, function(response) {
                    MessageManager.addErrorMessage($translate.instant('CHECKIN_CHECKOUT.CHECKIN_MODAL.ERROR_FETCHING_RESOURCE_INFO'));
                    deferred.reject();
                });
                return deferred.promise;
            };

            $scope.hasPath = function() {
                return !$scope.inRootLayout();
            };

            $scope.friendlyFolderName = function(folder) {
                var folderId;

                if (typeof folder === 'string') {
                    folderId = folder;
                } else {
                    folderId = folder.Id;
                }

                // TODO: Fetch the strings from a Resource Provider for localization
                if (folderId === userInfo.RootFolderId) {
                    return $translate.instant('TOP_NAV.MY_DOCUMENTS');
                } else if (folderId === userInfo.RecycleBinFolderId) {
                    return $translate.instant('TOP_NAV.RECYCLE_BIN');
                }

                return folder.Name || folderId;
            };

            $scope.isFolderShared = function(folder) {
                return folder && folder.SharedWithOrganization;
            };

            $scope.isDocumentShared = function(doc) {
                return doc && (doc.SharedAnonymously || doc.SharedWithOrganization);
            };

            $scope.isRootFolder = function(folder) {
                var folderId = (typeof folder === 'string') ? folder : folder.Id;
                return (folderId === userInfo.RootFolderId || folderId === userInfo.RecycleBinFolderId);
            };
            $scope.supportSortOwner = function() {
                return ($scope.folderState.view === viewTypes.SHARED_TYPE) || ($scope.folderState.view === viewTypes.AWAITING_FEEDBACK_TYPE) || ($scope.folderState.view === viewTypes.FAVORITES);
            };

            $scope.inOwn = function() {
                return $scope.folderState.view === viewTypes.OWN_TYPE || userInfo.RootFolderId === $scope.folderState.activeFolderId;
            };

            //Will return true if the current layout is a sub folder view
            $scope.inFolderView = function() {
                return $scope.folderState.view === viewTypes.FOLDER_TYPE && $routeParams.folderId !== userInfo.RootFolderId;
            };

            $scope.inShared = function() {
                return ($scope.folderState.view === viewTypes.SHARED_TYPE);
            };

            $scope.inSharedByMe = function() {
                return $scope.folderState.view === viewTypes.SHARED_BY_ME_TYPE || View === viewTypes.SHARED_BY_ME_TYPE;
            };

            $scope.inFavorites = function() {
                return ($scope.folderState.view === viewTypes.FAVORITES);
            };

            $scope.inFeedback = function() {
                return ($scope.folderState.view === viewTypes.AWAITING_FEEDBACK_TYPE);
            };

            $scope.inReview = function() {
                return ($scope.folderState.view === viewTypes.OUT_FOR_REVIEW_TYPE);
            };

            $scope.inRecycle = function() {
                return $scope.folderState.view === viewTypes.RECYCLE_TYPE || userInfo.RecycleBinFolderId === $scope.folderState.activeFolderId;
            };

            $scope.inRecovery = function() {
                return $scope.folderState.view === viewTypes.RECOVERY_TYPE;
            };

            $scope.inRecycleDeep = function() {
               return ($scope.inRecycle() || $scope.folderState.inRecycle);
            };

            $scope.inRootLayout = function() {
                return $scope.inOwn() || $scope.inShared() || $scope.inFeedback() || $scope.inSharedByMe() ||
                    $scope.inReview() || $scope.inRecycle() || View === viewTypes.FAVORITES || View === viewTypes.RECOVERY_TYPE;
            };

            $scope.showEmptyMessage = function() {
                return $scope.documents && $scope.documents.length === 0 && $scope.folders && $scope.folders.length === 0;
            };

            $scope.showRightTab = function(tabName) {
                $timeout(function() {
                    $scope.$broadcast(SignalProvider.Sidebar.ChangeRight, tabName);
                }, 0);
            };

            $scope.showRightTabSliding = function(tabName) {
                $timeout(function() {
                    $scope.$broadcast(SignalProvider.Sidebar.SlideRight, tabName);
                }, 0);
            };

            // called form 'share button' in people side bar.
            $scope.showShareCurrentFolderModal = function() {
                // New Modal
                ClientMetricsService.startLatencyEvent(MetricEvents.NEW_FOLDER_SHARE_MODAL_DWELL_TIME_NO_CHANGES);
                ClientMetricsService.startLatencyEvent(MetricEvents.NEW_FOLDER_SHARE_MODAL_DWELL_TIME_WITH_CHANGES);
                //VERY IMPORTANT: Always use a closure copy of the current folder ID. Do not refer to the master copy (fileManager.getCurrentFolder() value) again.
                var currentExecFolderId = fileManager.getCurrentFolder();
                shareModal = $uibModal.open({
                    templateUrl: './share-modal/share_modal_dialog.html',
                    controller: 'gbShareModalCtrl',
                    size: 'lg',
                    resolve: {
                        inFolderView: function() {
                            return true;
                        },
                        isAnonymous: function() {
                            return false;
                        },
                        isFolder: function() {
                            return true;
                        },
                        pendingShareType: function() {
                            return TYPE_FOLDER;
                        },
                        shareResourceId: function() {
                            //VERY IMPORTANT: Always use a closure copy of the current folder ID. Do not refer to the master copy (fileManager.getCurrentFolder() value) again.
                            return currentExecFolderId;
                        },
                        shareResourceName: function() {
                            return $scope.pageTitle;
                        },
                        currentOwnerInfo: function() {
                            return $scope.userInfo;
                        },
                        shareOnly: function() {
                             return 'FOLDER';
                        },
                        currentOwnerUsername: function() {
                            return $scope.folderState.activeFolderOwnerUsername;
                        },
                        CommentsLocked : function() {
                            return null;
                        }
                    }
                });

                shareModal.result.then(function(response) {
                    syncView($scope.sortOption.sortBy, $scope.sortOption.order, true);
                    shareModal = null;
                    if (response && response.isOpenShareLinkModal){
                    	$scope.showNewShareLinkFolderModal({
                            //VERY IMPORTANT: Always use a closure copy of the current folder ID. Do not refer to the master copy (fileManager.getCurrentFolder() value) again.
                    		Id: currentExecFolderId,
                    		Name: $scope.pageTitle
                    	});
                    }
                }, function() {
                    shareModal = null;
                });
                closeModalOnScopeIsDestroied(shareModal);
            };

            $scope.showNewShareDocumentModal = function(doc) {
                ClientMetricsService.startLatencyEvent(MetricEvents.NEW_DOCUMENT_SHARE_MODAL_DWELL_TIME_NO_CHANGES);
                ClientMetricsService.startLatencyEvent(MetricEvents.NEW_DOCUMENT_SHARE_MODAL_DWELL_TIME_WITH_CHANGES);

                function successCallback(response){
                    var data = response.data;
                    if (!data || !data.Metadata || !data.Metadata.VersionMetadata) {
                        errorCallback();
                        return;
                    }

                    shareModal = $uibModal.open({
                        templateUrl: './share-modal/share_modal_dialog.html',
                        controller: 'gbShareModalCtrl',
                        size: 'lg',
                        resolve: {
                            inFolderView: function() {
                                return true;
                            },
                            isFolder: function() {
                                return false;
                            },
                            isAnonymous: function() {
                                return false;
                            },
                            pendingShareType: function() {
                                return TYPE_DOCUMENT;
                            },
                            shareResourceId: function() {
                                return doc.Id;
                            },
                            shareResourceName: function() {
                                return doc.VersionMetadata.Name;
                            },
                            currentOwnerInfo: function() {
                                return $scope.userInfo;
                            },
                            currentOwnerUsername: function() {
                                return $scope.folderState.activeFolderOwnerUsername;
                            },
                            shareOnly: function() {
                                return null;
                            },
                            CommentsLocked : function() {
                                return data.Metadata.CommentsLocked;
                            }
                        }
                    });

                    shareModal.result.then(function(response) {
                        FileCountService.signal();
                        shareModal = null;
                        if (response && response.isOpenShareLinkModal){
                        	$scope.showNewShareLinkDocumentModal(doc);
                        }
                    }, function() {
                        shareModal = null;
                    });
                }

                function errorCallback(){
                     MessageManager.addErrorMessage(MessageProvider.documentAccessFailDefault);
                }

                DocumentService.getDocument(doc.Id)
                    .then(successCallback, errorCallback);
            };

            $scope.showNewShareFolderModal = function(folderInfo) {
                ClientMetricsService.startLatencyEvent(MetricEvents.NEW_FOLDER_SHARE_MODAL_DWELL_TIME_NO_CHANGES);
                ClientMetricsService.startLatencyEvent(MetricEvents.NEW_FOLDER_SHARE_MODAL_DWELL_TIME_WITH_CHANGES);

                shareModal = $uibModal.open({
                    templateUrl: './share-modal/share_modal_dialog.html',
                    controller: 'gbShareModalCtrl',
                    size: 'lg',
                    resolve: {
                        inFolderView: function() {
                            return true;
                        },
                        isFolder: function() {
                            return true;
                        },
                        isAnonymous: function() {
                            return false;
                        },
                        pendingShareType: function() {
                            return TYPE_FOLDER;
                        },
                        shareResourceId: function() {
                            return folderInfo.Id;
                        },
                        shareResourceName: function() {
                            return folderInfo.Name;
                        },
                        currentOwnerInfo: function() {
                            return $scope.userInfo;
                        },
                        shareOnly: function() {
                             return 'FOLDER';
                         },
                        currentOwnerUsername: function() {
                            return $scope.folderState.activeFolderOwnerUsername;
                        },
                        CommentsLocked : function() {
                            return null;
                        }
                    }
                });

                shareModal.result.then(function(response) {
                    syncView($scope.sortOption.sortBy, $scope.sortOption.order, true);
                    shareModal = null;
                    if (response && response.isOpenShareLinkModal){
                    	$scope.showNewShareLinkFolderModal(folderInfo);
                    }
                }, function() {
                    shareModal = null;
                });
            };

            $scope.showNewShareLinkDocumentModal = function(doc) {
                ClientMetricsService.startLatencyEvent(MetricEvents.DOCUMENT_SHARE_LINK_MODAL_DWELL_TIME_NO_CHANGES);
                ClientMetricsService.startLatencyEvent(MetricEvents.DOCUMENT_SHARE_LINK_MODAL_DWELL_TIME_WITH_CHANGES);

                function successCallback(response){
                    var data = response.data;
                    if (!data || !data.Metadata || !data.Metadata.VersionMetadata ) {
                        errorCallback();
                        return;
                    }

                    shareModal = $uibModal.open({
                        templateUrl: './share-modal/share_link_modal_dialog.html',
                        controller: 'gbShareLinkModalCtrl',
                        size: 'sl',
                        resolve: {
                            inFolderView: function() {
                                return true;
                            },
                            isFolder: function() {
                                return false;
                            },
                            pendingShareType: function() {
                                return TYPE_DOCUMENT;
                            },
                            shareResourceId: function() {
                                return doc.Id;
                            },
                            shareResourceName: function() {
                                return doc.VersionMetadata.Name;
                            },
                            isAnonymous: function() {
                                return $scope.layout.isAnonymous;
                            },
                            currentOwnerOrganizationId: function() {
                                return $scope.userInfo.OrganizationId;
                            },
                            currentOwnerUsername: function() {
                                return $scope.folderState.activeFolderOwnerUsername;
                            }
                        }
                    });

                    shareModal.result.then(function(response) {
                        FileCountService.signal();
                        shareModal = null;
                        updateSharedInfoDocument(doc.Id, response.isSiteLink, response.isAnyoneLink);
                    }, function() {
                        shareModal = null;
                    });
                }

                function errorCallback(){
                     MessageManager.addErrorMessage(MessageProvider.documentAccessFailDefault);
                }

                DocumentService.getDocument(doc.Id)
                    .then(successCallback, errorCallback);
            };

            $scope.showSharedByMeResourceModal = function() {

                var sharedByMeResourceModal = $uibModal.open({
                        templateUrl: './share-modal/shared_by_me_resource_filter_dialog.html',
                        controller: 'FilterSharedByMeResourceController',
                    });

                sharedByMeResourceModal.result.then(function(results) {
                	    $scope.currentSharedByMeFilter.startTime = results.startTime;
                	    $scope.currentSharedByMeFilter.endTime = results.endTime;
                	    $scope.currentSharedByMeFilter.resourceCategory = results.resourceCategory;
                	    syncView($scope.sortOption.sortBy, $scope.sortOption.order, true);
                	    sharedByMeResourceModal = null;
                    }, function() {
                    	sharedByMeResourceModal = null;
                    });
                closeModalOnScopeIsDestroied(sharedByMeResourceModal);
            };

            $scope.showNewShareLinkFolderModal = function(folderInfo) {
            	ClientMetricsService.startLatencyEvent(MetricEvents.FOLDER_SHARE_LINK_MODAL_DWELL_TIME_NO_CHANGES);
                ClientMetricsService.startLatencyEvent(MetricEvents.FOLDER_SHARE_LINK_MODAL_DWELL_TIME_WITH_CHANGES);

                shareModal = $uibModal.open({
                	templateUrl: './share-modal/share_link_modal_dialog.html',
                    controller: 'gbShareLinkModalCtrl',
                    size: 'sl',
                    resolve: {
                        inFolderView: function() {
                            return true;
                        },
                        isFolder: function() {
                            return true;
                        },
                        pendingShareType: function() {
                            return TYPE_FOLDER;
                        },
                        shareResourceId: function() {
                            return folderInfo.Id;
                        },
                        shareResourceName: function() {
                            return folderInfo.Name;
                        },
                        isAnonymous: function() {
                            return $scope.layout.isAnonymous;
                        },
                        currentOwnerOrganizationId: function() {
                            return $scope.userInfo.OrganizationId;
                        },
                        currentOwnerUsername: function() {
                            return $scope.folderState.activeFolderOwnerUsername;
                        }
                    }
                });

                shareModal.result.then(function(response) {
                    syncView($scope.sortOption.sortBy, $scope.sortOption.order, true);
                    shareModal = null;
                    updateSharedInfoFolder(folderInfo.Id, response.isSiteLink);
                }, function() {
                    shareModal = null;
                });
            };

            function updateSharedInfoFolder(folderId, sharedWithOrg){
                if (folderId === $scope.folderState.activeFolderId) {
                    $scope.metadata.SharedWithOrganization = sharedWithOrg;
                }
                $scope.folders.forEach(function(folder) {
                    if (folder.Id === folderId) {
                        folder.SharedWithOrganization = sharedWithOrg;
                    }
                });
            }

            function updateSharedInfoDocument(documentId, sharedWithOrg, sharedAnon){
              $scope.documents.forEach(function(document) {
                  if (document.Id === documentId) {
                    document.SharedWithOrganization = sharedWithOrg;
                    document.SharedAnonymously = sharedAnon;
                  }
              });
            }

            $scope.$on(SignalProvider.ShareLink.Created, function(event, param){

                var sharedWithOrg = false, sharedAnon = false;
                 switch(param.linkScope){
                      case 'ANYONE':
                          sharedAnon = true;
                          break;
                      case 'SITE_VIEWER':
                      case 'SITE_CONTRIBUTOR':
                          sharedWithOrg = true;
                          break;
                 }

                 if (param.resourceType == "DOCUMENT") {
                      updateSharedInfoDocument(param.resourceId, sharedWithOrg, sharedAnon);
                 } else if (param.resourceType == "FOLDER") {
                      updateSharedInfoFolder(param.resourceId, sharedWithOrg);
                 }
            });

            $scope.showMoveModal = function(docOrFolder) {
                var moveSource = {
                    docs: [],
                    folders: []
                };
                if (docOrFolder.VersionMetadata) {
                    // Document
                    moveSource.docs.push({
                        id: docOrFolder.Id,
                        name: docOrFolder.VersionMetadata.Name
                    });
                } else if (docOrFolder.Name) {
                    // Folder
                    moveSource.folders.push({
                        id: docOrFolder.Id,
                        name: docOrFolder.Name
                    });
                }
                moveModalInternal(moveSource);
            };

            function moveModalInternal(moveSource) {
                // Make a move modal visible.
                var moveModal = $uibModal.open({
                    templateUrl: './move-modal/move_dialog.html',
                    controller: 'moveModalCtrl',
                    resolve: {
                        sources: function() {
                            return moveSource;
                        },
                        isRecovering: function() {
                            return false;
                        }
                    }
                });

                moveModal.result.then(function(shouldUpdate) {
                    if (angular.isUndefined(shouldUpdate)) {
                        shouldUpdate = true;
                    }

                    if (shouldUpdate) {
                        syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);
                        $scope.fileManagerInstance.clearSelected();
                    }
                    moveModal = null;
                }, function() {
                    moveModal = null;
                });

                $scope.$on("$destroy", () => {
                    if (moveModal) {
                        moveModal.close();
                    }
                });
            }

            $scope.showTransferModal = function(docOrFolder) {
                var resourcesToTransfer = [];

                if ($scope.folderState.itemsSelectedCount > 0) {
                    angular.forEach($scope.selectedDocuments, function(file) {
                        resourcesToTransfer.push({
                            id: file.Id,
                            name: file.VersionMetadata.Name
                        });
                    });

                    angular.forEach($scope.selectedFolders, function(folder) {
                        resourcesToTransfer.push({
                            id: folder.Id,
                            name: folder.Name
                        });
                    });
                }

                transferModal = $uibModal.open({
                    templateUrl: './transfer-modal/transfer_dialog.html',
                    controller: 'TransferModalCtrl',
                    resolve: {
                        resourcesToTransfer: function() {
                            return resourcesToTransfer;
                        }
                    }
                });

            };

            $scope.showEmptyRecycleBinModal = function() {
                if ($scope.folderState.itemsSelectedCount > 0) {
                    bulkDeleteModal = $uibModal.open({
                        templateUrl: 'bulkDeleteModal.html',
                        scope: $scope
                    });

                    bulkDeleteModal.result.then(function() {
                        bulkDeleteModal = null;
                    }, function() {
                        bulkDeleteModal = null;
                    });
                } else {
                    emptyRecycleBinModal = $uibModal.open({
                        templateUrl: 'emptyRecycleBinModal.html',
                        scope: $scope
                    });

                    emptyRecycleBinModal.result.then(function() {
                        emptyRecycleBinModal = null;
                    }, function() {
                        emptyRecycleBinModal = null;
                    });
                }
            };

            $scope.showCreateNoteModal = function() {
                $scope.noteState.noteErrorText = '';
                createNoteModal = $uibModal.open({
                    templateUrl: 'createNoteModal.html',
                    scope: $scope
                });

                createNoteModal.result.then(function() {
                    createNoteModal = null;
                }, function() {
                    createNoteModal = null;
                });
            };

            $scope.showBulkDeleteModal = function() {
                bulkDeleteModal = $uibModal.open({
                    templateUrl: 'bulkDeleteModal.html',
                    scope: $scope
                });

                bulkDeleteModal.result.then(function() {
                    bulkDeleteModal = null;
                }, function() {
                    bulkDeleteModal = null;
                });
            };

            $scope.downloadFolder = function(folder) {
                CompanionService.downloadFolder(folder);
            };

            $scope.isFavoritesEnabled = function(){
                var featureEnabledState = FeatureManagerService.isFeatureEnabled(Features.UI.FAVORITES) || false;
                var isMinimalUser = userInfo.MinimalUser
                return featureEnabledState && !isMinimalUser;
            };

            $scope.showTransferButton = function() {
                return FeatureManagerService.isFeatureEnabled(Features.UI.SHOW_TASKS) &&
                    $scope.layout.view === AppConstants.ViewTypes.OWN_TYPE ||
                    $scope.layout.view === AppConstants.ViewTypes.SHARED_BY_ME_TYPE ||
                    ($scope.layout.view === AppConstants.ViewTypes.FOLDER_TYPE && !$scope.folderState.deepInSharedFolder);
            };

            $scope.isTaskEnabled = function(){
                var featureEnabledState = FeatureManagerService.isFeatureEnabled(Features.UI.SHOW_TASKS) || false;
                return featureEnabledState;
            };

            $scope.isRecoveryEnabled = function() {
              var params = $location.search();
              return FeatureManagerService.isFeatureEnabled(Features.UI.RECOVERY_FOLDER) && userInfo.Administrator && !!params.userId;
            };

            $scope.upload = function() {
                $('#id_file_input2').click();
            };

            $scope.$on(SignalProvider.ContentLoading.LoadMore, function($event, data) {
                $scope.loadMore();
                $event.stopPropagation();
            });

            $scope.clickedOnResource = function(folder) {
                fileManager.setCurrentFolder(folder.Id);
                syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);
            };

            $scope.openNewNote = function(note) {
                userInfo.NoteInfo.LastActiveNoteId = note.Id;
                $scope.constructOnlineEditorUrl(note).then(function(onlineEditingUrl) {
                    (document.getElementById(ONLINE_EDITOR_IFRAME_ELEMENT_ID) as any).src = onlineEditingUrl;
                }, function(errorResponse) {
                    console.log("Error in openFileInOnlineEditor : ",errorResponse);
                });
            };

            $scope.constructOnlineEditorUrl = function(document) {
                var editorApp = "WRITE_EDITOR";
                var contentType = document.VersionMetadata.ContentType;
                switch (contentType) {
                case 'application/vnd.ms-excel':
                case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                    editorApp = "CALC_EDITOR";
                    break;

                case 'application/vnd.ms-powerpoint':
                case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                    editorApp = "SHOW_EDITOR";
                    break;
                }

                return AuthService.onAccessTokenRefreshTick().then(function() {
                return TokenService.createSecureTokenHancom(document.Id, null, 'UNUSED').then(function(token) {
                    return EndpointService.hancomEndpoint() + encodeURIComponent(document.VersionMetadata.Name) +
                        '/open?app=' + encodeURIComponent(editorApp) +
                        '&lang=en_us&fid=' + encodeURIComponent(document.Id) +
                        '&user_id=' + encodeURIComponent(userInfo.Id) +
                        '&uiOption=' + encodeURIComponent('000000') +
                        '&region=' + encodeURIComponent(RegionService.getRealRegion()) +
                        '&access_token=' + encodeURIComponent(token);

                }, function(errorResponse) {
                    console.log("Unable to get secure token :", errorResponse);
                });
                });
            };


            $scope.loadMore = function(allPages) {
                if ($scope.contentLoadingPromise !== null || !fileManager.getMarker()) {
                    return $scope.contentLoadingPromise;
                }
                var deferred = $q.defer();
                $rootScope.$broadcast(SignalProvider.ContentLoading.Start);
                ClientMetricsService.startLatencyEvent(MetricEvents.FETCH_MORE_RESOURCES_EVENT);
                if(!$scope.inSharedByMe()) {
                    if (allPages) {
                        //Get all pages exhaustively only if we haven't done so before.
                        loadRestAll();
                    } else {
                    	fileManager.loadMore().then(loadMoreSuccessFn, loadMoreFailureFn);
                    }
                } else {
                	if (allPages) {
                        //Get all pages exhaustively only if we haven't done so before.
                		fileManager.loadMoreSharedByMeResources().then(loadMorePartialSuccessFn, loadMoreFailureFn);
                    } else {
                    	fileManager.loadMoreSharedByMeResources().then(loadMoreSuccessFn, loadMoreFailureFn);
                    }
                }

                $scope.contentLoadingPromise = deferred.promise;
                $scope.contentLoadingPromise.finally(function() {
                    $scope.contentLoadingPromise = null;
                });
                return $scope.contentLoadingPromise;

                function loadRestAll() {
                    fileManager.loadMore().then(loadMorePartialSuccessFn, loadMoreFailureFn);
                }

                function loadMorePartialSuccessFn(result) {
                    if (result.hasMore) {
                        loadRestAll();
                    } else {
                        loadMoreSuccessFn(result);
                    }
                }

                function loadMoreSuccessFn(result) {
                    setDocumentsAndFolders();

                    if ($scope.folderState.view === viewTypes.SHARED_TYPE) {
                        updateUsers($scope.documents, $scope.folders);
                    }
                    $scope.getCheckoutUsersInfo($scope.documents);
                    checkForOfficeUnlockSignal($scope.documents);

                    if ($scope.folderState.view !== viewTypes.FAVORITES) {
                        $scope.applyFavorites($scope.documents, $scope.folders, Favorites);
                    }
                    deferred.resolve(result);

                    ClientMetricsService.stopAndRecordLatencyEvent(MetricEvents.FETCH_MORE_RESOURCES_EVENT);
                    // Cache the documents we already have when coming from the list view so the prev/next document feature can use them.
                    GetNextDocumentService.setDocsExclusively(fileManager.getFiles(), $scope.folderState.activeFolderId);
                    GetNextDocumentService.setMarker(fileManager.getMarker(), $scope.folderState.activeFolderId);
                }

                function loadMoreFailureFn(response) {
                    $rootScope.$broadcast(SignalProvider.ContentLoading.Done);
                    deferred.reject(response);
                }
            };

            $scope.changeSortOrder = function(option, currentSortOrder) {
            	if ($scope.inSharedByMe()) {
            		return;
            	}
                if ($scope.sortOption.text !== option.text) {
                    // if choosing different sort criterion, choose that criterion's default sort order
                    $scope.sortOption = option;
                    $scope.sortOrder = option.order;
                } else {
                    // otherwise, just flip the order
                    $scope.sortOrder = SortService.getOppositeOrder($scope.sortOrder);
                    $scope.sortOption.order = $scope.sortOrder;
                }

                SortService.setSortOption($scope.folderState.view, $scope.folderState.viewType, $scope.sortOption);
                if (!!fileManager.getMarker()) {
                    $scope.folderState.loaded = false;
                }
                fileManager.sort($scope.sortOption.sortBy, $scope.sortOrder)
                    .then(function success (folderResult) {
                        setDocumentsAndFolders(true);
                        if (folderResult && folderResult.folder) {

                            // Cache the documents we already have when coming from the list view so the prev/next document feature can use them.
                            GetNextDocumentService.setDocsExclusively(fileManager.getFiles(), $scope.metadata.Id);
                            GetNextDocumentService.setMarker(fileManager.getMarker(), $scope.metadata.Id);
                        }
                    }, function error(err) {
                        $scope.layout.hasRightSidebar = false;
                        $scope.layout.showLeftSidebar = true;
                        $scope.folderState.folderErrorCode = err.result ? err.result.status : err.status;
                        document.title = AppConstants.APP_NAME;
                    });
            };


            $scope.getShareLinkTooltip = function(resourceType) {
            	if (resourceType === 'folder') {
            		return $translate.instant('SHARE_LINK.DOCUMENT_VIEWER.FOLDER_LINK_TOOLTIP');
            	} else if (resourceType === 'document') {
            		return $translate.instant('SHARE_LINK.DOCUMENT_VIEWER.DOCUMENT_LINK_TOOLTIP');
            	}
            };

            $scope.getRequestDate = function(file) {
                if (!!file.FeedbackRequestMetadata) {
                    return file.FeedbackRequestMetadata.FeedbackRequestTimestamp;
                }
                return null;
            };

            $scope.getFeedbackDeadline = function(file) {
                if (!!file.FeedbackRequestMetadata) {
                    return file.FeedbackRequestMetadata.FeedbackRequestDeadline;
                }
                return null;
            };

            $scope.getFolderPermissions = function(folderId) {
                return fileService.getFolder(folderId);
            };

            $scope.checkoutDocumentCommonForFileBrowser = function(docId) {
                return $scope.checkoutDocumentCommon(docId).then(function(response) {
                    $scope.documents.forEach(function(doc) {
                        if (doc.Id === docId) {
                            doc.CheckoutInfo = response.data.CheckoutInfo;
                            // update user's right for resources
                            delete $scope.userActionsMap[docId];
                            $scope.getUserRightsForResource(docId, 'file');
                        }
                    });
                });
            };

            $scope.isOfficeFile = function(document){
                if (_.endsWith(document.VersionMetadata.Name, AppConstants.WOPI_TEST_EXT)) {
                    return true;
                }
                return ContentTypeFormatter.isOfficeFile(document.VersionMetadata.ContentType);
            };

            $scope.isOnlineEditableFileFormat = function(document) {
                return ContentTypeFormatter.isOnlineEditableFileFormat(document.VersionMetadata.ContentType);
            };

            $scope.isOfficeLegacyFile = function(resource){
                if (!resource.VersionMetadata) {
                    return;
                }
                return ContentTypeFormatter.isOfficeLegacyFile(resource.VersionMetadata.ContentType);
            };

            $scope.unlockDocumentCommonForFileBrowser = function(docId) {
                //Do not use Array.find(), that does not exist in IE
                var doc = _.find($scope.documents, function(doc) {
                    return doc.Id === docId;
                });
                var promise;
                if($scope.isDocumentCheckedOutByOtherUser(doc)) {
                    promise = $scope.discardCheckoutForProprietor(docId, doc.VersionMetadata.Name);
                } else {
                    promise = $scope.unlockDocumentCommon(docId, doc.VersionMetadata.Name);
                }
                return promise.then(function() {
                    //If the modal promise is resolved, then remove the checkout info in document
                    $scope.documents.forEach(function(doc) {
                        if (doc.Id === docId) {
                            doc.CheckoutInfo = null;
                            // update user's right for resources
                            delete $scope.userActionsMap[docId];
                            $scope.getUserRightsForResource(docId, 'file');
                        }
                    });
                });
            };

            $scope.discardCheckoutCommon = function(docId) {

                //Do not use Array.find(), that does not exist in IE
                var doc = _.find($scope.documents, function(doc) {
                    return doc.Id === docId;
                });
                var promise;
                if($scope.isDocumentCheckedOutByOtherUser(doc)) {
                    promise = $scope.discardCheckoutForProprietor(docId, doc.VersionMetadata.Name);
                } else {
                    promise = $scope.discardCheckoutForCheckoutee(docId);
                }
                promise.then(function() {
                    //If the modal promise is resolved, then remove the checkout info in document
                    $scope.documents.forEach(function(doc) {
                        if (doc.Id === docId) {
                            doc.CheckoutInfo = null;
                            // update user's right for resources
                            delete $scope.userActionsMap[docId];
                            $scope.getUserRightsForResource(docId, 'file');
                        }
                    });
                });
            };


            $scope.checkoutDocument = function(doc) {
                return $q(function(resolve, reject) {
                    $scope.getUserRightsForResource(doc.Id, 'file').then(function() {
                        if($scope.userActionsMap[doc.Id].canCheckout) {
                            return $scope.checkoutDocumentCommonForFileBrowser(doc.Id).then(resolve, reject);
                        } else {
                            $scope.showPermissionDeniedMessage();
                            reject();
                        }
                    }, function() {
                        $scope.showPermissionDeniedMessage();
                        reject();
                    });
                });
            };

            $scope.releaseLock = function(doc) {
                if (doc.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.APP) {
                    //no op
                    return $q.reject('locked by app');
                }

                return $q(function(resolve, reject) {
                    $scope.getUserRightsForResource(doc.Id, 'file').then(function() {
                        if($scope.userActionsMap[doc.Id].canDiscardCheckout || $scope.userActionsMap[doc.Id].canCheckin ||
                            $scope.userActionsMap[doc.Id].canForceCheckin) {
                            return $scope.unlockDocumentCommonForFileBrowser(doc.Id).then(resolve, reject);
                        } else {
                            $scope.showPermissionDeniedMessage();
                            reject();
                        }
                    }, function() {
                        $scope.showPermissionDeniedMessage();
                        reject();
                    });
                });
            };

            $scope.onActionBarRemoveMeFromShare = function() {
                var documents = fileManager.selectedFiles(),
                    folders = fileManager.selectedFolders();

                if (!$scope.inShared()) {
                    return;
                }

                $q.all([
                    documents.map(doc => $scope.getUserRightsForResource(doc, TYPE_DOCUMENT)).
                    concat(folders.map(folder => $scope.getUserRightsForResource(folder, TYPE_FOLDER))
                )])
                .then(() => {

                    var removeSelfFromShareConfirmModal = $uibModal.open({
                        templateUrl: 'removeSelfFromShareConfirmModal.html'
                    });

                    $scope.$on('$destroy', function() {
                        if (removeSelfFromShareConfirmModal) {
                            removeSelfFromShareConfirmModal.close();
                        }
                    });

                    return removeSelfFromShareConfirmModal.result.then(function() {
                        var allResources = documents.concat(folders);

                        const validResourceFilterFn = resource => $scope.userActionsMap[resource].canRemoveFromShare;
                        const invalidResourceFilterFn = resource => !validResourceFilterFn(resource);

                        var invalidDocs = documents.filter(invalidResourceFilterFn);
                        var invalidFolders = folders.filter(invalidResourceFilterFn);

                        var validDocs = documents.filter(validResourceFilterFn);
                        var validFolders = folders.filter(validResourceFilterFn);

                        var invalidDocsText = invalidDocs.map(docId => {
                            const doc : DocMetadata = $scope.__getFileById(TYPE_DOCUMENT, docId);
                            return doc.VersionMetadata.Name;
                        }).join(' <br /> ');

                        var invalidFoldersText = invalidFolders.map(folderId => {
                            const folder : FolderMetadata = $scope.__getFileById(TYPE_FOLDER, folderId);
                            return folder.Name;
                        }).join(' <br /> ');

                        validDocs.map(doc => $scope.__getFileById(TYPE_DOCUMENT, doc))
                            .concat(validFolders.map(folder => $scope.__getFileById(TYPE_FOLDER, folder)))
                            .map(resourceObj => $scope.removeFromShare(resourceObj));

                        if (invalidDocs.length || invalidFolders.length) {
                            ModalFactory.showAlertModal( $scope,
                                $translate.instant('MODAL.REMOVE_ME_FROM_SHARE.INVALID_RESOURCES.TITLE'),
                                $translate.instant('MODAL.REMOVE_ME_FROM_SHARE.INVALID_RESOURCES.MESSAGE') + '<br />' +
                                invalidFoldersText + '<br />' +
                                invalidDocsText,
                                $translate.instant('MODAL.REMOVE_ME_FROM_SHARE.INVALID_RESOURCES.OKAY_BTN')
                            );
                        }

                    }).finally(function() {
                        removeSelfFromShareConfirmModal = null;
                    });
                });
            };

            $scope.onActionBarToggleFavorite = function(favorite: boolean) {
                var documents = fileManager.selectedFiles(),
                    folders = fileManager.selectedFolders();

                const selectorFn = resource => !!resource.isFavorite === !favorite;

                documents.map(docId => {
                    return $scope.__getFileById(TYPE_DOCUMENT, docId);
                })
                .filter(selectorFn)
                .forEach($scope.toggleFavorite);

                folders.map(folderId => {
                    return $scope.__getFileById(TYPE_FOLDER, folderId);
                })
                .filter(selectorFn)
                .forEach($scope.toggleFavorite);
            };

            $scope.onActionBarDiscardChangesAndUnlock = function() {
                var docId = fileManager.selectedFiles()[0];
                $scope.discardCheckoutCommon(docId);
            };

            $scope.discardChangesAndUnlockHandler = function(doc) {
                var docId = doc.Id;
                $scope.discardCheckoutCommon(docId);
            };

            $scope.onActionBarCheckout = function() {
                var docId = fileManager.selectedFiles()[0];
                /*
                 * Notice: check permission (fetch from server if necessary) before checkout
                 * Though userActionsMap[docId] should be always defined, it is still a good idea to check
                 */
                $scope.getUserRightsForResource(docId, 'file').then(function() {
                    if($scope.userActionsMap[docId].canCheckout) {
                        $scope.checkoutDocumentCommonForFileBrowser(docId);
                    } else {
                        $scope.showPermissionDeniedMessage();
                    }
                }, $scope.showPermissionDeniedMessage);
            };

            $scope.fileBrowserRequestCheckinCommon = function(doc) {
                var isProprietor = false;
                if ($scope.currentUserRoles) {
                    isProprietor = $scope.currentUserRoles.some(function(role) {
                        return role.role === globalRoles.OWNER || role.role === globalRoles.COOWNER;
                    });
                }
                $scope.requestCheckin(doc.Id, doc.CheckoutInfo.CheckoutUserName, isProprietor);
            };

            $scope.requestCheckinDocument = function(doc) {
                ClientMetricsService.addLogsToSession({
                    event: UIEvents.DOCUMENT_VIEWER.DROPDOWN_MENU_CLICKS.REQUEST_CHECKIN,
                    metadata: userInfo.Id,
                });
                $scope.fileBrowserRequestCheckinCommon(doc);
            };

            $scope.onActionBarRequestCheckin = function() {
                ClientMetricsService.addLogsToSession({
                    event: UIEvents.DOCUMENT_VIEWER.DROPDOWN_MENU_CLICKS.REQUEST_CHECKIN,
                    metadata: userInfo.Id,
                });
                var selectedItem;
                if ($scope.selectedFileCount !== 1) {
                    // The button shouldn't be available if 0 or 2+ files are selected, but better safe than sorry.
                    return;
                }
                selectedItem = $scope.__getSingleSelectedItem();
                if (selectedItem && selectedItem.type === TYPE_DOCUMENT) {
                    $scope.fileBrowserRequestCheckinCommon(selectedItem.value);
                }
            };

            $scope.onActionBarOpenWithOffice = function() {
                var selectedItem;

                if ($scope.selectedFileCount !== 1) {
                    // The button shouldn't be available if 0 or 2+ files are selected, but better safe than sorry.
                    return;
                }

                selectedItem = $scope.__getSingleSelectedItem();
                if (selectedItem) {
                    var resourceId = selectedItem.value.Id,
                        versionId = selectedItem.value.VersionMetadata.VersionId,
                        contentType = selectedItem.value.VersionMetadata.ContentType;

                    if (selectedItem.type === TYPE_DOCUMENT) {
                        $location.url('/document/' + resourceId+ '?officeEditor=true');
                    }

                    var event = {
                        event: MetricEvents.O365.OFFICE_FILE_OPENED_BROWSER_VIEW.name,
                        documentId : resourceId,
                        versionId : versionId,
                        documentType : contentType

                    };

                    ClientMetricsService.addEventObjectToSession(event);
                }
            };

            $scope.onActionBarEditOnline = function() {
                var selectedItem;

                if ($scope.selectedFileCount !== 1) {
                    // The button shouldn't be available if 0 or 2+ files are selected, but better safe than sorry.
                    return;
                }

                selectedItem = $scope.__getSingleSelectedItem();
                if (selectedItem) {
                    var resourceId = selectedItem.value.Id,
                        versionId = selectedItem.value.VersionMetadata.VersionId;

                    if (selectedItem.type === TYPE_DOCUMENT) {
                        $location.url('/document/' + resourceId+ '?editOnline=true');
                    }

                    var event = {
                        name: "ACTION_BAR_EDIT_ONLINE",
                        documentId : resourceId,
                        versionId : versionId
                    };

                    ClientMetricsService.addEventToSession(event);
                }
            };

            /**
             * Occurs when the user clicks on the open button in the top action bar.
             */
            $scope.onActionBarOpen = function() {
                var selectedItem;

                if ($scope.selectedFileCount !== 1) {
                    // The button shouldn't be available if 0 or 2+ files are selected, but better safe than sorry.
                    return;
                }

                selectedItem = $scope.__getSingleSelectedItem();
                if (selectedItem) {
                    var resourceId = selectedItem.value.Id;
                    if (selectedItem.type === TYPE_DOCUMENT) {
                        $location.path('/document/' + resourceId);
                    } else {
                        $location.path('/folder/' + resourceId);
                    }
                }
            };

            $scope.onActionBarEdit = function() {
                var selectedItem;
                if ($scope.selectedFileCount !== 1) {
                    return;
                }

                selectedItem = $scope.__getSingleSelectedItem();
                if (selectedItem.type === TYPE_DOCUMENT) {
                    $scope.openInFrictionlessEdit(selectedItem.value);
                }
            };

            /**
             * Occurs when the user clicks on the Share button in the top action bar.
             */
            $scope.openShareModal = function(selectedItem) {
                if (selectedItem.type === TYPE_DOCUMENT) {
                    $scope.showNewShareDocumentModal(selectedItem.item);
                } else {
                    $scope.showNewShareFolderModal(selectedItem.item);
                }
            };

            $scope.getShareLabel = function(){
            	return ($scope.isAnonymousSharingEnabled)?
            			$translate.instant('FILE_ACTIONS.SHARE_INVITE') : $translate.instant('FILE_ACTIONS.SHARE');
            };

            /**
             * Occurs when the user clicks on the share button in the dropdown list
             * Add feature manager to switch between the current one and the new one
             */
            $scope.pickShareFolderModal = function(folder) {
                if (folder.Id === $scope.folderState.activeFolderId) {
                    if ($scope.hasSharePermission()) {
                        $scope.showNewShareFolderModal(folder);
                    } else {
                        $scope.showPermissionDeniedMessage();
                    }
                } else {
                    $scope.getUserRightsForResource(folder.Id, 'folder').then(function() {
                        if($scope.userActionsMap[folder.Id].canShare) {
                            $scope.showNewShareFolderModal(folder);
                        } else {
                            $scope.showPermissionDeniedMessage();
                        }
                    }, $scope.showPermissionDeniedMessage);
                }

            };

            $scope.isOrgWideLinkSharingEnabled = function() {
                return AppConstants.ORG_WIDE_SHARING_SCOPE !== 'NONE';
            }

            $scope.pickShareDocumentModal = function(doc) {
                $scope.getUserRightsForResource(doc.Id, 'file').then(function() {
                    if($scope.userActionsMap[doc.Id].canShare) {
                        $scope.showNewShareDocumentModal(doc);
                    } else {
                        $scope.showPermissionDeniedMessage();
                    }
                }, $scope.showPermissionDeniedMessage);
            };

            $scope.showPermissionDeniedMessage = function() {
                MessageManager.addInfoMessage($translate.instant('FILE_ACTIONS.NO_PERMISSION'));
            };

            /**
             * Occurs when the user clicks on the share a link button in the dropdown list OR on the link icon in the list view column
             */
            $scope.onShareLinkClicked = function(selectedItem) {
                if(selectedItem.type === TYPE_DOCUMENT) {
                    $scope.pickShareLinkDocumentModal(selectedItem.item);
                } else {
                    $scope.pickShareLinkFolderModal(selectedItem.item);
                }
            };

            $scope.pickShareLinkFolderModal = function(folder) {
                if (folder.Id === $scope.folderState.activeFolderId) {
                    if ($scope.hasShareLinkPermission()) {
                        $scope.showNewShareLinkFolderModal(folder);
                    } else {
                        $scope.showPermissionDeniedMessage();
                    }
                } else {
                    $scope.getUserRightsForResource(folder.Id, 'folder').then(function() {
                        if($scope.userActionsMap[folder.Id].canShareLink) {
                            $scope.showNewShareLinkFolderModal(folder);
                        } else {
                            $scope.showPermissionDeniedMessage();
                        }
                    }, $scope.showPermissionDeniedMessage);
                }
            };

            $scope.pickShareLinkDocumentModal = function(doc) {
                $scope.getUserRightsForResource(doc.Id, 'file').then(function() {
                    if($scope.userActionsMap[doc.Id].canShareLink) {
                        $scope.showNewShareLinkDocumentModal(doc);
                    } else {
                        $scope.showPermissionDeniedMessage();
                    }
                }, $scope.showPermissionDeniedMessage);
            };

            $scope.openInFrictionlessEdit = function(doc, useDrive) {
                $scope.getUserRightsForResource(doc.Id, 'file').then(function() {
                    // Applicability check
                    if (!useDrive && !CompanionService.isCompanionConnectionPossible()) {
                        CompanionService.showCompanionNotSupportedModal();
                        return;
                    }
                    
                    // Permission check
                    if(!$scope.userActionsMap[doc.Id].canEdit) {
                        return;
                    }

                    // Do the real business once the permission check passed.
                    // If the document is already locked by the current user, edit it directly.
                    if ($scope.isDocumentCheckedOutByLoggedInUserCommon(doc)) {
                        if (useDrive) {
                            CompanionService.openInDrive(doc);
                        } else {
                            CompanionService.openInFrictionlessEdit(doc, null);
                        }
                        return;
                    }
                    var LockAndEditModal = $uibModal.open({
                        templateUrl: './shared/lock-and-edit-modal/lock-and-edit.html',
                        controller: 'lockAndEditController',
                        windowClass : 'dialog-box-2018 medium-style',
                        resolve: {
                            doc: doc,
                            lockFile: function() {
                                return $scope.checkoutDocument;
                            },
                            editWithCompanion: function() {
                                return useDrive ? CompanionService.openInDrive : CompanionService.openInFrictionlessEdit;
                            }
                        }
                    });
                    closeModalOnScopeIsDestroied(LockAndEditModal);
                }, $scope.showPermissionDeniedMessage);
            };

            $scope.openInDrive= function(doc) {
                $scope.getUserRightsForResource(doc.Id, 'file').then(function() {
                    
                    // Permission check
                    if(!$scope.userActionsMap[doc.Id].canEdit) {
                        return;
                    }

                    // Do the real business once the permission check passed.
                    // If the document is already locked by the current user, edit it directly.
                    if ($scope.isDocumentCheckedOutByLoggedInUserCommon(doc)) {
                        CompanionService.openInDrive(doc);
                        return;
                    }
                    var LockAndEditModal = $uibModal.open({
                        templateUrl: './shared/lock-and-edit-modal/lock-and-edit.html',
                        controller: 'lockAndEditController',
                        windowClass : 'dialog-box-2018 medium-style',
                        resolve: {
                            doc: doc,
                            lockFile: function() {
                                return $scope.checkoutDocument;
                            },
                            editWithCompanion: function() {
                                return CompanionService.openInDrive;
                            }
                        }
                    });
                    closeModalOnScopeIsDestroied(LockAndEditModal);
                }, $scope.showPermissionDeniedMessage);
            };

            $scope.editOnline = function(doc) {
                $location.url('/document/' + doc.Id+ '?editOnline=true');
                var event = {
                    name: "DROPDOWN_EDIT_ONLINE",
                    documentId : doc.Id,
                    versionId : doc.VersionMetadata.VersionId
                };
                ClientMetricsService.addEventToSession(event);
            };

            $scope.liveEditAction = function(document,currentLocationHash) {
                $scope.getUserRightsForResource(document.Id, 'file').then(function(){
                    if($scope.isDocumentCheckedOutByO365(document) && $scope.userActionsMap[document.Id].canEditWithO365 && $rootScope.isO365FeatureEnabled()){
                        $rootScope.goto('/document/' + document.Id + '?officeEditor=true&siteReturnPath=' + currentLocationHash);
                    } else if($scope.isDocumentCheckedOutByHancom(document) && $scope.userActionsMap[document.Id].canEditOnline && !$scope.userActionsMap[document.Id].editOnlineDisableMessage && $rootScope.isFeatureEnabled(Features.DocumentViewer.ONLINEEDITING)){
                        $scope.editOnline(document);
                    } else {
                        $scope.showPermissionDeniedMessage();
                    }
                }, $scope.showPermissionDeniedMessage);
            };

            /**
             * Occurs when the user clicks on the Move button in the top action bar.
             */
            $scope.onActionBarBulkMove = function() {
                if ($scope.selectedFileCount <= 0) {
                    return;
                }

                const selectedDocs = fileManager.selectedFiles(),
                    selectedFolders = fileManager.selectedFolders();

                moveModalInternal({
                    docs: $scope.documents.filter(doc => selectedDocs.indexOf(doc.Id) !== -1).map(doc => ({
                        id: doc.Id,
                        name: doc.VersionMetadata.Name
                    })),
                    folders: $scope.folders.filter(folder => selectedFolders.indexOf(folder.Id) !== -1).map(folder => ({
                        id: folder.Id,
                        name: folder.Name
                    })),
                });
            };

            /**
             * Occurs when the user clicks on the Delete button in the top action bar.
             */
            $scope.onActionBarDelete = function() {
                var selectedItem;

                if ($scope.selectedFileCount <= 0) {
                    return;
                }

                if ($scope.selectedFileCount === 1) {
                    selectedItem = $scope.__getSingleSelectedItem();
                    if (selectedItem) {
                        if (selectedItem.type === TYPE_DOCUMENT) {
                            $scope.confirmDocumentDelete(selectedItem.value);
                        } else {
                            $scope.confirmFolderDelete(selectedItem.value);
                        }
                    }
                } else {
                    $scope.showBulkDeleteModal();
                }
            };

            $scope.createNote = function() {
                var noteName = $scope.modals.noteName + ".note";
                var defaultContent = JSON.stringify({ "ops": [{"insert": "New Note..."}]});
                //Do not use Array.find(), that does not exist in IE
                var matchingDocs = _.find($scope.documents, function(doc){
                    return doc.VersionMetadata.Name == noteName;
                });

                if (!angular.isUndefined(matchingDocs)){
                    $scope.noteState.noteErrorText = MessageProvider.noteCreateFailAlreadyExists(noteName);
                    return;
                }

                DocumentService.InitiateDocumentVersionUpload(
                                                        "", // empty will create a new document
                                                        noteName,
                                                        "workdocs/note",
                                                        defaultContent.length,
                                                        $scope.metadata.Id)
                .success(function(data) {
                    var s3url = data.DocumentVersionUrl;
                    var versionId = data.Metadata.LatestVersionMetadata.Id;
                    var docId = data.Metadata.Id;
                    var headers = data.UploadMetadata.SignedHeaders;
                    headers["Content-Type"] = "workdocs/note";
                    headers["Content-Disposition"] = 'filename="' + noteName + '"'
                    if (s3url) {
                        $.ajax({
                            url: s3url,
                            type: 'PUT',
                            data: defaultContent,
                            processData: false,
                            headers: headers,
                            success: function(response) {
                                DocumentService.updateDocumentVersion(docId, versionId)
                                .success(function(data){
                                    // false will force the folder to update
                                    syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);
                                })
                                .error(function(data) {
                                    $log.error("[Notes] ERROR: Failed to upload to S3 docName = " +
                                                    noteName);
                                });
                            },
                            error: function(response) {
                                $log.error('[Notes] Error uploading to S3 : ' + response.statusText);
                            }
                        });
                    }
                })
                .error(function(data) {
                    $log.error("[Notes] ERROR: Failed to InitiateDocumentVersionUpload new document docName = " +
                                    noteName);
                });

                if (createNoteModal) {
                    createNoteModal.close();
                }
            };

            // call from single file action drop down menu in file list view
            $scope.confirmDocumentDelete = function(doc) {
                var deleteDocumentModal;

                if ($scope.folderState.deepInSharedFolder || $scope.inShared()) {
                    deleteDocumentModal = $uibModal.open({
                        templateUrl: 'deleteDocumentModal.html',
                    });
                    deleteDocumentModal.result.then(function() {
                        $scope.deleteDocument(doc);
                    }).finally(function() {
                        deleteDocumentModal = null;
                    });

                    //Close the modal when user navigates away from the page
                    closeModalOnScopeIsDestroied(deleteDocumentModal);
                } else {
                    $scope.deleteDocument(doc);
                }
            };

            // call from single file action drop down menu in file list view
            $scope.confirmFolderDelete = function(folder) {
                return $q(function(resolve, reject) {
                    if ($scope.folderState.deepInSharedFolder || $scope.inShared()) {
                        //This confirmation modal just asks for confirmation. It's not responsible for calling deleteFolder(), this ctrl is
                        deleteFolderModal = $uibModal.open({
                            templateUrl: 'deleteFolderModal.html',
                            controller : ['$scope', function($scope) {
                                $scope.folderName = folder.Name;
                            }]
                        });
                        deleteFolderModal.result.then(function() {
                            deleteFolderModal = null;
                            $scope.deleteFolder(folder).then(resolve, reject);
                        }, function() {
                            deleteFolderModal = null;
                            reject();
                        });

                    } else {
                        $scope.deleteFolder(folder).then(resolve, reject);
                    }
                });
            };

            $scope.deleteFolder = function(folder) {
                var folderId = folder.Id;
                var deleteMethod = (View === viewTypes.RECYCLE_TYPE) ? 'deleteFolderPermanently' : 'moveFolderToTrash';

                // Remove item from list with filter.
                function removeFolderFilter(folder) {
                    return (folder.Id !== folderId);
                }

                // Hide the delete confirmation modal dialog
                if (deleteFolderModal) {
                    deleteFolderModal.close();
                }

                return fileService[deleteMethod](folderId)
                .then(function success() {
                    FileCountService.signal();

                    delete $scope.selectedFolders[folderId];

                    if (View !== viewTypes.RECYCLE_TYPE) {
                        SessionManager.setDeletedItems([], [folderId]);
                    }
                    var ownerId = getOwnerId(folder);
                    if (View !== viewTypes.RECYCLE_TYPE && ownerId !== userInfo.Id) {
                        UserCollectionService.getUserCollection([ownerId])
                        .then(function(Users) {
                            MessageManager.addSuccessMessage($translate.instant('MESSAGES.FOLDER_DELETE_SUCCESS_MOVED_TO_OWNERS_RECYCLE_BIN', {
                                userName: $rootScope.getFullName(Users[ownerId])
                            }));
                        });
                    } else {
                        MessageManager.addSuccessMessage(MessageProvider.folderFolderDeleteSuccess);
                    }
                    $scope.folders = $filter('filter')($scope.folders, removeFolderFilter, true);
                    fileManager.removeFilesAndFolders([], [folderId]);
                    FileCountService.signal();
                    MessageManager.addSuccessMessage(MessageProvider.folderFolderDeleteSuccess);

                    fileManager.clearSelected();
                }, function error(errorMsg, result) {
                    if (errorMsg && errorMsg.indexOf('EntityNotExistsException') >= 0) {
                        MessageManager.addErrorDeleteMessage(MessageProvider.folderFolderDeleteAlreadyExists, [folder.Name], []);

                        delete $scope.selectedFolders[folderId];
                        fileManager.removeFilesAndFolders([], [folderId]);
                        $scope.folders = $filter('filter')($scope.folders, removeFolderFilter, true);
                    } else {
                        MessageManager.addErrorDeleteMessage(MessageProvider.folderFolderDeleteFailDefault(folder.Name), [folder.Name], []);
                    }
                    return $q.reject();
                })
                .finally(function() {
                    setTimeout(function() {
                        $rootScope.$broadcast(SignalProvider.ContentLoading.Done);
                    });
                });
            };

            $scope.deleteDocument = function(doc) {
                var docId = doc.Id;
                var deleteMethod = (View === viewTypes.RECYCLE_TYPE) ? 'deleteFilePermanently' : 'moveFileToTrash';

                function removeDocumentFilter(docItem) {
                    return (docItem.Id !== docId);
                }

                fileService[deleteMethod](docId)
                .then(function() {
                    FileCountService.signal();

                    delete $scope.selectedDocuments[docId];
                    fileManager.removeFilesAndFolders([docId], []);

                    if (View !== viewTypes.RECYCLE_TYPE) {
                        SessionManager.setDeletedItems([docId], []);
                    }
                    var ownerId = getOwnerId(doc);
                    if (View !== viewTypes.RECYCLE_TYPE && ownerId !== userInfo.Id) {
                        UserCollectionService.getUserCollection([ownerId])
                        .then(function(Users) {
                            MessageManager.addSuccessMessage($translate.instant('MESSAGES.FOLDER_DOCUMENT_DELETE_SUCCESS_MOVED_TO_OWNERS_RECYCLE_BIN', {
                                userName: $rootScope.getFullName(Users[ownerId])
                            }));
                        });
                    } else {
                        MessageManager.addSuccessMessage(MessageProvider.folderDocumentDeleteSuccess);
                    }
                    $scope.documents = $filter('filter')($scope.documents, removeDocumentFilter, true);
                    fileManager.clearSelected();
                }, function(reason) {
                    if (reason.message && reason.message.indexOf('EntityNotExistsException') >= 0) {
                        MessageManager.addErrorDeleteMessage(MessageProvider.folderDocumentDeleteNotExists, [], [doc.VersionMetadata.Name]);
                        delete $scope.selectedDocuments[docId];
                        fileManager.removeFilesAndFolders([docId], []);
                        $scope.documents = $filter('filter')($scope.documents, removeDocumentFilter, true);
                    } else {
                        MessageManager.addErrorMessage(MessageProvider.folderDocumentDeleteFailDefault(doc.VersionMetadata.Name));
                    }
                })
                .finally(function() {
                    setTimeout(function() {
                        $rootScope.$broadcast(SignalProvider.ContentLoading.Done);
                    });
                });
            };



            $scope.bulkDelete = function() {
                if (bulkDeleteModal) {
                    bulkDeleteModal.close();
                }

                var deleteMethod, fileIds, fileNames, folderIds, folderNames;

                deleteMethod = ($scope.folderState.view === viewTypes.RECYCLE_TYPE) ? 'deletePermanently' : 'moveToTrash';

                $scope.failedFolders = [];
                $scope.failedDocuments = [];

                $scope.folderCount = 0;
                $scope.documentCount = 0;

                fileNames = _.mapValues($scope.selectedDocuments, function(file) {
                    return file.VersionMetadata.Name;
                });
                fileIds = _.keys(fileNames);
                $scope.documentCount = fileIds.length;

                folderNames = _.mapValues($scope.selectedFolders, 'Name');
                folderIds = _.keys(folderNames);
                $scope.folderCount = folderIds.length;

                fileService[deleteMethod]({
                    files: fileIds,
                    folders: folderIds
                }).then(function() {
                    FileCountService.signal();

                    $scope.documents = $filter('filter')($scope.documents, function(doc: any) {
                        return !$scope.selectedDocuments[doc.Id];
                    }, true);
                    $scope.folders = $filter('filter')($scope.folders, function(folder: any) {
                        return !$scope.selectedFolders[folder.Id];
                    }, true);
                    fileManager.removeFilesAndFolders(fileIds, folderIds);

                    $scope.selectedFolders = {};
                    $scope.selectedDocuments = {};

                    $scope.folderState.itemsSelected = false;

                    if ($scope.folderState.view !== viewTypes.RECYCLE_TYPE) {
                        SessionManager.addToDeletedItems(fileIds, folderIds);
                        MessageManager.addSuccessMessage(MessageProvider.folderBulkFileDeletedSuccess);
                    } else {
                        MessageManager.addSuccessMessage(MessageProvider.folderBulkFilePermanentDeletedSuccess);
                    }

                    fileManager.clearSelected();
                }, function(reason) {
                    if (reason.result && reason.result.status !== 404) {
                        if (reason.fileType === 'file') {
                            $scope.failedDocuments.push(fileNames[reason.fileId]);
                        } else if (reason.fileType === 'folder') {
                            $scope.failedFolders.push(folderNames[reason.folderId]);
                        }
                    }

                    if ($scope.failedFolders.length > 0) {
                        MessageManager.addErrorDeleteMessage(MessageProvider.folderBulkFolderDeleteFail($scope.failedFolders), $scope.failedFolders, []);
                    } else if ($scope.failedDocuments.length > 0) {
                        MessageManager.addErrorDeleteMessage(MessageProvider.folderBulkDocumentDeleteFail($scope.failedDocuments), [], $scope.failedDocuments);
                    }
                })
                .finally(function() {
                    setTimeout(function() {
                        $rootScope.$broadcast(SignalProvider.ContentLoading.Done);
                    });
                });
            };

            $scope.emptyRecycleBin = function() {
                if (emptyRecycleBinModal) {
                    emptyRecycleBinModal.close();
                }

                fileManager.emptyTrash()
                .then(function() {
                    $timeout(function() {
                        FileCountService.emptyRecycleBin();
                    }, 500);
                    setDocumentsAndFolders();
                    MessageManager.addSuccessMessage(MessageProvider.folderEmptyRecycleBinSuccess);
                }, function(reason) {
                    $log.error("Deleting folder content has failed with error: " + reason);
                    MessageManager.addErrorMessage(MessageProvider.folderEmptyRecycleBinError);
                });

            };

            $scope.restoreFileOrFolder = function(docOrFolder) {
                //reset previous selections first to make sure, this action does not act on old selections
                $scope.selectedDocuments = {};
                $scope.selectedFolders = {};

                if (docOrFolder.VersionMetadata) {
                    $scope.selectedDocuments[docOrFolder.Id] = docOrFolder;
                } else {
                    $scope.selectedFolders[docOrFolder.Id] = docOrFolder;
                }
                updateNumberSelectedItems();
                $scope.restoreSelectedFiles();
            };

            $scope.restoreSelectedFiles = function() {
                var fileIds, folderIds;
                if ($scope.folderState.itemsSelectedCount > 0) {
                    fileIds = _.keys($scope.selectedDocuments);
                    folderIds = _.keys($scope.selectedFolders);

                    fileService.restoreFromTrash({
                        files: fileIds,
                        folders: folderIds
                    }).then(function(data) {
                        FileCountService.signal();

                        $scope.documents = $filter('filter')($scope.documents, function(doc: any) {
                            return !$scope.selectedDocuments[doc.Id];
                        }, true);
                        $scope.folders = $filter('filter')($scope.folders, function(folder: any) {
                            return !$scope.selectedFolders[folder.Id];
                        }, true);
                        fileManager.removeFilesAndFolders(fileIds, folderIds);

                        $scope.selectedDocuments = {};
                        $scope.selectedFolders = {};

                        MessageManager.addSuccessMessage(MessageProvider.folderRestoreSuccess);
                        fileManager.clearSelected();
                    }, function(reason) {
                        MessageManager.addErrorDeleteMessage(MessageProvider.folderRestoreFailDefault);
                    });
                }
            };

            /**
             * This method takes the user to the immediate parent folder, if that's accessible. Otherwise it
             * takes the user to /mydocs page
             *
             */
            $scope.gotoAccessibleParentFolder = function() {
                fileService.getFolder($scope.metadata.ParentFolderId, {})
                .then(function() {
                    if ($scope.metadata.ParentFolderId === userInfo.RootFolderId) {
                        $location.url('/mydocs');
                    } else {
                        $location.url('/folder/' + encodeURIComponent($scope.metadata.ParentFolderId));
                    }
                }, function() {
                    $location.url('/mydocs');
                });
            };

            $scope.onDeleteCurrentFolder = function() {
                $scope.confirmFolderDelete($scope.metadata)
                .then($scope.gotoAccessibleParentFolder);
            };

            $scope.showMoveCurrentFolderModal = function() {
                $scope.showMoveModal($scope.metadata);
            };

            $scope.removeMeFromSharedForCurrentFolder = function() {
                $scope.removeMeFromShared($scope.metadata)
                .then($scope.gotoAccessibleParentFolder);
            };

            $scope.showRenameCurrentFolderModal = function() {
                var modalHandle = $uibModal.open({
                    templateUrl: './shared/rename_modal.html',
                    controller: 'ResourceRenameModalCtrl',
                    size : 'lg',
                    resolve: {
                        FileOrFolder: function() {
                            return $scope.metadata;
                        }
                    }
                });
                closeModalOnScopeIsDestroied(modalHandle);
                modalHandle.result.then(function(newName) {
                    syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);
                }).finally(function() {
                    modalHandle = null;
                });
            };

            // call from single file action drop down menu.
            $scope.renameFile = function(docOrFolder) {
                $scope.docOrFolderInEditing = docOrFolder.Id;
            };

            // call from single file action drop down menu.
            $scope.removeMeFromShared = function(docOrFolder) {
                var removeSelfFromShareConfirmModal = $uibModal.open({
                    templateUrl: 'removeSelfFromShareConfirmModal.html'
                });

                $scope.$on('$destroy', function() {
                    if (removeSelfFromShareConfirmModal) {
                        removeSelfFromShareConfirmModal.close();
                    }
                });

                return removeSelfFromShareConfirmModal.result.then(function() {
                    return $scope.removeFromShare(docOrFolder);
                }).finally(function() {
                    removeSelfFromShareConfirmModal = null;
                });
            };

            $scope.removeFromShare = function(docOrFolder) {
                var pendingRemoveType, pendingRemoveFromShareName;
                if (!docOrFolder.VersionMetadata) {
                    //does not have versions, and is therefore a folder
                    pendingRemoveType = TYPE_FOLDER;
                    pendingRemoveFromShareName = docOrFolder.Name;
                } else {
                    //does have versions, and is therefore a document
                    pendingRemoveType = TYPE_DOCUMENT;
                    pendingRemoveFromShareName = docOrFolder.VersionMetadata.Name;
                }
                function removeShareFilter(docOrFolderItem) {
                    return (docOrFolderItem.Id !== docOrFolder.Id);
                }

                // Use new API
                return ResourceService.deleteResourcePermission(docOrFolder.Id, userInfo.Id)
                .then(function success() {
                    FileCountService.signal();
                    if (pendingRemoveType === TYPE_FOLDER) {
                        delete $scope.selectedFolders[docOrFolder.Id];

                        $scope.folders = $filter('filter')($scope.folders, removeShareFilter, true);
                        fileManager.removeFilesAndFolders([], [docOrFolder.Id]);

                        MessageManager.addSuccessMessage(MessageProvider.folderRemoveFromShareSuccess(pendingRemoveFromShareName));
                    } else if (pendingRemoveType === TYPE_DOCUMENT) {
                        delete $scope.selectedDocuments[docOrFolder.Id];

                        $scope.documents = $filter('filter')($scope.documents, removeShareFilter, true);
                        fileManager.removeFilesAndFolders([docOrFolder.Id], []);

                        MessageManager.addSuccessMessage(MessageProvider.documentRemoveFromShareSuccess(pendingRemoveFromShareName));
                    }
                    fileManager.clearSelected();
                }, function error(data, status, headers, config) {
                    if (pendingRemoveType === TYPE_FOLDER) {
                        if (data.Message && data.Message.indexOf('EntityNotExistsException') >= 0) {
                            MessageManager.addErrorDeleteMessage(MessageProvider.folderFolderDeleteAlreadyExists, [pendingRemoveFromShareName], []);
                            $scope.folders = $filter('filter')($scope.folders, removeShareFilter, true);
                            fileManager.removeFilesAndFolders([], [docOrFolder.Id]);
                        } else {
                            MessageManager.addErrorDeleteMessage(MessageProvider.folderFolderDeleteFailDefault(pendingRemoveFromShareName), [pendingRemoveFromShareName], []);
                        }

                    } else if (pendingRemoveType === TYPE_DOCUMENT) {
                        if (data.Message && data.Message.indexOf('EntityNotExistsException') >= 0) {
                            MessageManager.addErrorDeleteMessage(MessageProvider.folderDocumentDeleteNotExists, [], [$scope.pendingDeleteDocumentName]);
                            $scope.documents = $filter('filter')($scope.documents, removeShareFilter, true);
                            fileManager.removeFilesAndFolders([docOrFolder.Id], []);
                        } else {
                            MessageManager.addErrorMessage(MessageProvider.documentRemoveFromShareFailDefault(pendingRemoveFromShareName));
                        }
                    }
                    return $q.reject();
                });
            };

            // call from single file action drop down menu.
            $scope.declineFeedback = function(doc) {
                DocumentService.declineFeedbackRequest(doc.Id, userInfo.Id)
                .success(function(data) {
                    FileCountService.signal();
                    fileManager.clearSelected();
                    syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);
                })
                .error(function(data, status, headers, config) {
                    MessageManager.addErrorMessage(MessageProvider.declineFeedbackFail(doc.VersionMetadata.Name));
                });
            };

            $scope.getVersionDownload = function(documentId, documentVersionId) {
                DocumentService.getDocumentVersionSource(documentId, documentVersionId, null)
                .success(function(data) {
                    var source = data.Metadata.Source,
                        sourceUrl = source.ORIGINAL;
                    $scope.updateDocumentSourceUrl(sourceUrl, data.Metadata.Size > 0);
                })
                .error(function(data, status, headers, config) {
                    if (data.Message.indexOf('EntityNotExistsException') >= 0) {
                        MessageManager.addErrorMessage(MessageProvider.documentDownloadFailNotExists);
                    } else if (data.Message.indexOf('UnauthorizedResourceAccessException') >= 0) {
                        MessageManager.addErrorMessage(MessageProvider.documentDownloadFailNoPermission);
                    }
                });
            };

            $scope.isSharedByMeFilterEnabled = function(){
            	return fileManager.isInSharedByMe() && FeatureManagerService.isFeatureEnabled(Features.UI.SHARED_BY_ME);
            };

            $scope.isFilteredBySharedLink = function() {
              return $scope.currentSharedByMeFilter.resourceCategory == $scope.sharedByMeCategory.SHAREABLE_LINK
                  || $scope.currentSharedByMeFilter.resourceCategory == $scope.sharedByMeCategory.ANONYMOUS_LINK;
            };

            $scope.showDeleteLinkModal = function() {
                if ($scope.folderState.itemsSelectedCount > 0) {
                  var title = $translate.instant('MODAL.BULK_DELETE_LINK_MODAL.TITLE'),
                      message = $translate.instant('MODAL.BULK_DELETE_LINK_MODAL.BULK_DELETE_LINK_MESSAGE'),
                      okayButtonText = $translate.instant('MODAL.BULK_DELETE_MODAL.DELETE_THEM'),
                      cancelButtonText = $translate.instant('MODAL.BULK_DELETE_MODAL.CANCEL');

                  ModalFactory.showConfirmationModal(title, message, okayButtonText, cancelButtonText).then(function() {
                      bulkDeleteLink();
                  }, function() {
                      // Do nothing on cancel
                  });
                }
            };

            function bulkDeleteLink() {

                var folderIds = fileManager.selectedFolders();
                var documentIds = fileManager.selectedFiles();

                var folderPrincipalId = _.mapValues($scope.selectedFolders, function(folder){
                    return (folder.SharedWithOrganization)? userInfo.OrganizationId : '';
                });
                var documentPrincipalId = _.mapValues($scope.selectedDocuments, function(document){
                    return (document.SharedWithOrganization)? userInfo.OrganizationId : ANONYMOUS_ID;
                });

                var promises = [];
                for (var i = 0; i < folderIds.length; i++) {
                    promises.push(ResourceService.deleteResourcePermission(folderIds[i], folderPrincipalId[folderIds[i]]));
                }
                for (var i = 0; i < documentIds.length; i++) {
                    promises.push(ResourceService.deleteResourcePermission(documentIds[i], documentPrincipalId[documentIds[i]]));
                }

                $q.all(promises).then(function success() {
                    MessageManager.addSuccessMessage(MessageProvider.bulkDeleteLinkSuccess);
                }, function error(reason){
                    MessageManager.addErrorMessage(MessageProvider.bulkDeleteLinkFailed);
                })
                .finally(function() {
                    fileManager.clearSelected();
                    syncView($scope.sortOption.sortBy, $scope.sortOption.order, true);
                });

            };

            $scope.isOnlineNoteEnabled = function() {
                return FeatureManagerService.isFeatureEnabled(Features.DocumentViewer.ONLINENOTES);
            };

            $scope.syncSharedByMeResourcesByCategory = function(category) {
        	    $scope.currentSharedByMeFilter.resourceCategory = category;
        	    syncView($scope.sortOption.sortBy, $scope.sortOption.order, true);

              // restart selected resources
              $scope.selectedFolders = {};
              $scope.selectedDocuments = {};
              $scope.folderState.itemsSelected = false;
              fileManager.clearSelected();
            };

            $scope.sharedLinkScope2ShortDescription = function(sharedLinkScope) {
                switch(sharedLinkScope) {
                    case null:
                        return $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_NO_LINK');
                    case AppConstants.SharedLinkScope.ANONYMOUS:
                        return $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_ANYONE');
                    case AppConstants.SharedLinkScope.SITE_VIEWER:
                        return $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_SITE_VIEWER');
                    case AppConstants.SharedLinkScope.SITE_CONTRIBUTOR:
                        return $translate.instant('MODAL.SHARE_MODAL.LINK_SCOPE_SITE_CONTRIBUTOR');
                    default:
                        return null;
                }
            };

            $scope.isNewApprovalPanelVisible = function() {
                return $scope.layout.showRightSidebar && $scope.sidebar.tabName === AppConstants.RightTabTypes.NEW_APPROVAL_REQUEST_TAB;
            };

            $scope.copySharedLinkToClipBoard = function() {
                var copySuccess = Utils.copyTextToClipboard(document, $scope.fileManagerInstance.getCurrentFolderSharedLinkUrl());
                if (!copySuccess) {
                    MessageManager.addErrorMessage($translate.instant('MESSAGES.LINK_COPY_CLIPBOARD'));
                }
            };

            $scope.showRecoverIntoMyDocModal = function() {
                var moveSource = {
                    docs: [],
                    folders: []
                };
                if ($scope.folderState.itemsSelectedCount > 0) {
                    if (!$.isEmptyObject($scope.selectedDocuments)) {
                        angular.forEach($scope.selectedDocuments, function(file) {
                            moveSource.docs.push({
                                id: file.Id,
                                name: file.VersionMetadata.Name
                            });
                        });
                    }
                    if (!$.isEmptyObject($scope.selectedFolders)) {
                        angular.forEach($scope.selectedFolders, function(folder) {
                            moveSource.folders.push({
                                id: folder.Id,
                                name: folder.Name
                            });
                        });
                    }
                }
                // We can re-use 'moveModal' since we are moving to mydocs
                recoverIntoMyDocsModal = $uibModal.open({
                    templateUrl: './move-modal/move_dialog.html',
                    controller: 'moveModalCtrl',
                    resolve: {
                        sources: function() {
                            return moveSource;
                        },
                        isRecovering: function(){
                            return true;
                        }
                    }
                });

                recoverIntoMyDocsModal.result.then(function(shouldUpdate) {
                    if (angular.isUndefined(shouldUpdate)) {
                        shouldUpdate = true;
                    }
                    if (shouldUpdate) {
                        syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);
                        $scope.selectedDocuments = {};
                        $scope.selectedFolders = {};
                        fileManager.clearSelected();
                    }
                    recoverIntoMyDocsModal = null;
                }, function() {
                    recoverIntoMyDocsModal = null;

                });
            };

            $scope.showMoveIntoSharedFolderModal = function(moveId, moveLocation, moveNewParentFolderId, moveSharedModalName) {
                moveIntoSharedModal = $uibModal.open({
                    templateUrl: 'moveIntoSharedModal.html',
                    controller: ['$scope', function($scope) {
                        $scope.moveSharedModalName = moveSharedModalName;
                    }]
                });

                return moveIntoSharedModal.result.then(function() {
                    moveIntoSharedModal = null;
                    return $scope.moveIntoFolder(moveId, moveLocation,moveNewParentFolderId,moveSharedModalName);
                }, function() {
                    moveIntoSharedModal = null;
                    return $q.reject();
                });
            };

            $scope.moveIntoFolder = function(moveId, moveLocation, moveNewParentFolderId) {
                if (moveIntoSharedModal) {
                    moveIntoSharedModal.close();
                }

                return fileService.moveIntoFolder(moveId, moveLocation, moveNewParentFolderId)
                .success(function() {
                    return true;
                })
                .error(function(data) {
                    // Add an error for folder creation failure to the notification list.
                    if (data.Message && data.Message.indexOf('EntityAlreadyExistsException') >= 0) {
                        MessageManager.addErrorUploadMessage(MessageProvider.folderUploadFailAlreadyExists);
                    } else {
                        MessageManager.addErrorUploadMessage(MessageProvider.folderUploadFailDefault);
                    }

                    syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);
                    return $q.reject();
                });
            };

            $scope.clickThumbnail = function() {
                if ($scope.folderState.viewType === AppConstants.GalleryTypes.LIST_VIEWTYPE) {
                    $scope.folderState.viewType = SessionManager.setPreferred(galleryTypes.THUMBNAIL_VIEWTYPE);
                    $scope.sortOption = SortService.getSortOption($scope.folderState.view, galleryTypes.THUMBNAIL_VIEWTYPE);
                    syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);
                    LayoutManager.resetRightScrollBarPosition();

                    //We need to reset the attempts map to make sure the attempts fire in thumbnail view
                    downloadMetadataAttempts = {};
                }
            };

            $scope.clickList = function() {
                if ($scope.folderState.viewType === AppConstants.GalleryTypes.THUMBNAIL_VIEWTYPE) {
                    $scope.folderState.viewType = SessionManager.setPreferred(galleryTypes.LIST_VIEWTYPE);
                    $scope.sortOption = SortService.getSortOption($scope.folderState.view, galleryTypes.LIST_VIEWTYPE);
                    syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);
                    LayoutManager.resetRightScrollBarPosition();
                    //We need to reset the attempts map to make sure the attempts fire in thumbnail view
                    downloadMetadataAttempts = {};
                }
            };

            // SECTION: Watch statements for stateful variables
            $scope.$on(SignalProvider.WorkDocsCompanion.ConnectionEstablished, function(event) {
                /* update cached action map */
                // flush cache
                $scope.userActionsMap = {};
                // for selected file
                var selectedItem = $scope.__getSingleSelectedItem();
                if(selectedItem) {
                    $scope.getUserRightsForResource(selectedItem.value.Id, selectedItem.type);
                }
                // for opened dropdown menu
                angular.forEach($scope.dropdownState, function(state, resourceId) {
                    if(state.isVisible) {
                        $scope.getUserRightsForResource(resourceId, state.resourceType);
                    }
                });
            });

            $scope.$on(SignalProvider.Permission.PrincipalRemoved, function() {
                // update view when principals are removed only in shared-by-me and out-for-review
                // because removing principals may effect the file/folder in these views
                if ($scope.layout.view === viewTypes.OUT_FOR_REVIEW_TYPE || $scope.layout.view === viewTypes.SHARED_BY_ME_TYPE) {
                    syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);
                }
            });

            $scope.$on(SignalProvider.Task.AccessRequestCreated, function() {
                $scope.userRequestedForThisFolderAlready = true;
            });

            $scope.$on(SignalProvider.Folder.RequestSyncView, function(event, requestedView) {
                // Sync the view only if the current view is requested.
                if (requestedView === $scope.folderState.view) {
                    syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);
                    $scope.docOrFolderInEditing = null;
                    fileManager.clearSelected();
                }
            });

            $scope.$on(SignalProvider.Folder.SyncCurrentView, function() {
                syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);
                $scope.docOrFolderInEditing = null;
                fileManager.clearSelected();
            });

            $scope.$on(SignalProvider.Folder.NotSyncCurrentView, function() {
                $scope.docOrFolderInEditing = null;
                fileManager.clearSelected();
            });

            $scope.$on('$destroy', function() {
                expBackOffTimerPromises.forEach(function(pendingPromise) {
                    $timeout.cancel(pendingPromise);
                });
                $rootScope.$broadcast(SignalProvider.Window.CloseModals);
            });

            $scope.$on('fileSelect', function(event, eventArgs) {
                // load user rights for resource when user selects resource.
                $scope.getUserRightsForResource(eventArgs.value, eventArgs.type);
            });
            $scope.$on('fileUnselect', updateTopActionBar);

            $scope.$on(SignalProvider.Document.Uploaded, function(event, docId, versionId) {
                updatePendingDocuments(docId, versionId);
                updateUsers($scope.documents, $scope.folders);
            });

            $scope.$on(SignalProvider.Permission.PermissionUpdated, function(){
                if ($scope.folderState.view === viewTypes.SHARED_BY_ME_TYPE) {
                  fileManager.clearSelected();
                  syncView($scope.sortOption.sortBy, $scope.sortOption.order, true);
                }
            });

            $scope.$watch('documents', function(newVal: DocMetadata[], oldVal: DocMetadata[]) {
                if (newVal && newVal.length) {
                    checkUpdatePending();
                }
            });

            $scope.$watch("[selectedDocuments, selectedFolders]", function() {
                if (!$.isEmptyObject($scope.selectedDocuments) || !$.isEmptyObject($scope.selectedFolders)) {
                    $scope.folderState.itemsSelected = true;
                } else {
                    $scope.folderState.itemsSelected = false;
                }
                updateNumberSelectedItems();
            }, true);

            // Tracks all route changes in the controller
            $scope.$on('$routeChangeSuccess', function(event, current) {
                ClientMetricsService.addPageViewToSession();
                ClientMetricsService.resetLatencyCounters();
            });

            PromiseWatcherService.init(MetricEvents.APP_LOAD_SERVICE_COMPLETE_EVENT, ClientMetricsService.recordAppLoadServiceComplete.bind(ClientMetricsService));

            if ($scope.inRootLayout()) {
                // $scope.layout.hasRightSidebar = false;
            } else {
                var getParams = $location.search();

                if (getParams.show) {
                    $scope.sidebar.tabName = getParams.show;
                    if ($scope.sidebar.tabs.indexOf($scope.sidebar.tabName) === -1) {
                        $scope.sidebar.tabName = $scope.sidebar.tabs[0];
                    }
                    $scope.showRightTab($scope.sidebar.tabName);
                }
            }

            updateNumberSelectedItems();

            // load current view
            syncView($scope.sortOption.sortBy, $scope.sortOption.order, false);

            //If we have newApprovalRequest flag in the route params, trigger the flow
            if ($routeParams.newApprovalRequest) {
                $timeout(() => {
                    $rootScope.$broadcast(SignalProvider.Sidebar.ToggleRight, AppConstants.RightTabTypes.NEW_APPROVAL_REQUEST_TAB);
                });
            }

            $rootScope.shouldPushToNova().then(function(pushToNova) {
                if(pushToNova){
                    $rootScope.forceUserToNovaMigration()
                }
            });
        }

        /**
         * Below are helper functions
         */

        function setRecoveryBinUserLabel(recoveryBinUser) {
            if (recoveryBinUser && userInfo.Id == recoveryBinUser.Id) {
                $scope.userRecoveryBinLabel = $translate.instant('TOP_NAV.MY_RECOVERY_BIN');
            } else {
                var recoveryBinUserName = $rootScope.getFullName(recoveryBinUser);
                $scope.userRecoveryBinLabel = $translate.instant('TOP_NAV.USERNAME_RECOVERY_BIN', {username: recoveryBinUserName});
            }
        }


        function checkUpdatePending() {
            var i, length = $scope.documents.length;
            for (i = 0; i < length; i++) {
                var docObj = $scope.documents[i];
                //Only call updatePendingDocuments if there's not already previous attempt made
                if (downloadMetadataAttempts[docObj.Id]) {
                    continue;
                }
                if (docObj 
                    && docObj.VersionMetadata 
                    && docObj.VersionMetadata.Status 
                    && docObj.VersionMetadata.Status !== 'INITIALIZED'
                    && docObj.VersionMetadata.PdfPreviewStatus 
                    && docObj.VersionMetadata.PdfPreviewStatus === 'PENDING') {
                    updatePendingDocuments(docObj.Id, docObj.VersionMetadata.VersionId);
                }
            }
        }

        var expBackOffTimerPromises = [];
        function updatePendingDocuments(docId, versionId, isRetry?: boolean) {
            function updateAttempts(docId) {
                if (downloadMetadataAttempts[docId]) {
                    downloadMetadataAttempts[docId]++;
                } else {
                    downloadMetadataAttempts[docId] = 1;
                }
            }

            /* This function is used to accomplish exponential backoff.
             * fn -> function that needs to be called after timer milliseconds
             * param -> param is the parameter that will be passed to the function
             * timer -> timer milliseconds after which fn is to be called. This needs to be doubled next time fn is called.
             */

            function exponentialBackOff(docId, versionId) {
                var timeoutVal = 1000 * Math.pow(2, downloadMetadataAttempts[docId]);
                if (timeoutVal > BACKOFF_THRESHOLD) {
                    timeoutVal = BACKOFF_THRESHOLD;
                }
                var timerPromise = $timeout(function() {
                    expBackOffTimerPromises = expBackOffTimerPromises.filter(function(item) {
                        return item !== timerPromise;
                    });
                    updatePendingDocuments(docId, versionId, true);
                }.bind(null, docId, versionId), timeoutVal);
                expBackOffTimerPromises.push(timerPromise);
            }
            // proceed only if there's not already previous attempt made
            if (!isRetry && downloadMetadataAttempts[docId]) {
                return;
            }
            updateAttempts(docId);
            DocumentService.getDocumentVersion(docId, versionId)
            .then(function(response) {
                var data = response.data,
                    versionMetadata = data.Metadata,
                    docIndex;
                versionMetadata.VersionId = versionMetadata.Id;

                if (versionMetadata.Size) {
                    var totalDocs = $scope.documents.length;
                    for (var i = 0; i < totalDocs; i++) {
                        if ($scope.documents[i].Id === docId) {
                            docIndex = i;
                            //The GetDocument API gives Thumbnail pictures in ThumbnailUrlMap property. The thumbnail view uses that map to show preview pictures
                            versionMetadata.ThumbnailUrlMap = versionMetadata.Thumbnail;
                            $scope.documents[docIndex].VersionMetadata = versionMetadata;
                            break;
                        }
                    }
                }

                if (!versionMetadata.Size || ($scope.folderState.viewType === AppConstants.GalleryTypes.THUMBNAIL_VIEWTYPE && versionMetadata.PdfPreviewStatus === 'PENDING')) {
                    exponentialBackOff(docId, versionId);
                }
            });
        }

        function canDelete(docOrFolder : any, userRights ?: any) {

            if ($scope.currentUserRoles) {
                var isDoc = !!docOrFolder.VersionMetadata,
                    isInheritedContributor = false;

                for (var i = 0; i < $scope.currentUserRoles.length; i++) {
                    var currentRole = $scope.currentUserRoles[i];

                    // inherited contributors are contributors whose roletype is INHERITED and principal type is USER
                    if (currentRole.role === globalRoles.CONTRIBUTOR && currentRole.roleType === AppConstants.RoleTypes.INHERITED && currentRole.principalType !== AppConstants.PrincipalTypes.ORGANIZATION) {
                        isInheritedContributor = true;
                    }
                }

                // This is to satisfy the documentation that an inherited contributor can delete files in a shared folder, but not folders.
                if (isDoc && isInheritedContributor) {
                    return true;
                }
            }

            // Currently, users do not have delete permission inside of the "Shared with me" root folder or "Awaiting Feedback."
            if (fileManager.isInTrash() || $scope.inFeedback()) {
                return false;
            }

            // Owners or co-owners can delete documents or folders.
            if (docOrFolder && getOwnerId(docOrFolder) === getUserId()) {
                return true;
            } else {
                return userRights && userRights.contains(permissions.DELETE);
            }
        }

        function canDownload(doc : any, userRights ?: any) {

            // Downloading quartz documents is not allowed in Rainier
            if(DocumentUtilities.isQuartzDocument(doc)) {
                return false;
            }
            // Download is not supported in the Recycle Bin.
            if (fileManager.isInTrash()) {
                return false;
            }

            // Owners can download their own files.
            // Anyone can download a file if the document level permissions grant downloads.
            if (doc && getOwnerId(doc) === getUserId()) {
                return true;
            } else {
                return userRights && userRights.contains(permissions.DOWNLOAD);
            }
        }

        function canCheckout(doc : DocMetadata, userRights ?: any) {
            // Editing is not supported in the Recycle Bin and also non Mac/Windows OS.
            if (fileManager.isInTrash() || !$scope.folderState.checkinCheckoutEnabled) {
                return false;
            }
            return (getOwnerId(doc) === getUserId() || (userRights && userRights.contains(permissions.CHECKOUT))) && !doc.CheckoutInfo && !$scope.isBasicUser;
        }

        //The following signature gives error, even though it seems correct. TODO: Investigate more..
        //function canDiscardCheckout(docInfo: DocMetadata, userRights ?: any) {
        function canDiscardCheckout(docInfo: any, docVersions: any, userRights ?: any) {
            // Editing is not supported in the Recycle Bin and also non Mac/Windows OS.
            if (fileManager.isInTrash() || !$scope.folderState.checkinCheckoutEnabled || $scope.isBasicUser) {
                return false;
            }
            var draftVersionExists = docVersions.some(function(version) {
                return version.VersionStatus === AppConstants.DOCUMENT_VERSION_STATUS.DRAFT;
            });
            return docInfo.Metadata.CheckoutInfo && draftVersionExists && !$scope.isBasicUser && (getOwnerId(docInfo.Metadata) === getUserId() || (userRights && userRights.contains(permissions.DISCARD_CHECKOUT)) || docInfo.Metadata.CheckoutInfo.CheckoutUserId === getUserId());
        }

        function canRequestCheckin(doc : DocMetadata, userRights ?: any) {
            if (!$scope.folderState.checkinCheckoutEnabled || !doc.CheckoutInfo ||

                //If the user itself has taken lock, then we don't show the "request checkin"
                ((!doc.CheckoutInfo.LockType || doc.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.USER) && doc.CheckoutInfo.CheckoutUserId === getUserId()) ||

                //If any app has taken the lock, then the "request checkin" flow does not apply
                (doc.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.APP)) {
                return false;
            }
            return getOwnerId(doc) === getUserId() || (userRights && userRights.contains(permissions.CHECKOUT));
        }

        function canEditOnline(doc: DocMetadata, userRights ?: any) {
            return $scope.isOnlineEditableFileFormat(doc) && !$scope.isBasicUser && canDownload(doc, userRights) && canUpload(doc, userRights) &&
            (!doc.CheckoutInfo || $scope.isDocumentCheckedOutByHancom(doc)) && $rootScope.onlineEditingEnabled && !BrowserService.isMobileOrTablet();
        }

        function getEditOnlineDisableMessage(doc : DocMetadata,userRights ?: any) {
            var disableMessage = '';

            if(ContentTypeFormatter.isPresentationFileFormat(doc.VersionMetadata.ContentType) &&
                doc.VersionMetadata.Size > AppConstants.LIMITS.HUNDRED_MB_IN_BYTES) {

                disableMessage = $translate.instant('ONLINEEDITING.ERRORS.PPT_FILE_SIZE_LIMIT_BREACHED');

            } else if(ContentTypeFormatter.isSpreadsheetFileFormat(doc.VersionMetadata.ContentType) &&
                doc.VersionMetadata.Size > AppConstants.LIMITS.THIRTY_MB_IN_BYTES) {

                disableMessage = $translate.instant('ONLINEEDITING.ERRORS.XLS_FILE_SIZE_LIMIT_BREACHED');

            } else if(ContentTypeFormatter.isWordFileFormat(doc.VersionMetadata.ContentType) &&
                doc.VersionMetadata.Size > AppConstants.LIMITS.FIFTY_MB_IN_BYTES) {

                disableMessage = $translate.instant('ONLINEEDITING.ERRORS.DOC_FILE_SIZE_LIMIT_BREACHED');

            } else if ($scope.isDocumentCheckedOut(doc) && !$scope.isDocumentCheckedOutByHancom(doc)) {
                disableMessage = $translate.instant('Hancom.OPTION_DISABLED_DUE_TO_LOCK');
            } else if (!$scope.isOnlineEditableFileFormat(doc)) {
                disableMessage = $translate.instant('Hancom.OPTION_DISABLED_REASON');
            } else if(!canDownload(doc, userRights) || !canUpload(doc, userRights)) {
                disableMessage = $translate.instant('ONLINEEDITING.ERRORS.CANNOT_EDIT_DOC_WITHOUT_DOWNLOAD_PERMISSION');
            }

            return disableMessage;
        }

        function canEdit(doc: DocMetadata, userRights ?:any) {
            var os = BrowserService.getOS(),
                osSupported = [OSTypes.WINDOWS, OSTypes.MAC].indexOf(os) > -1;

            // Editing is not supported in the Recycle Bin and also non Mac/Windows OS.
            if (fileManager.isInTrash() || !osSupported) {
                return false;
            }
            var editEnabled = FeatureManagerService.isFeatureEnabled(Features.UI.FRICTIONLESS_EDIT);
            var isDeviceSupported = !BrowserService.isMobileOrTablet();

            return canDownload(doc, userRights) && canUpload(doc, userRights) &&
                editEnabled && !$scope.isDocumentCheckedOutByAnApp(doc) && isDeviceSupported;
        }

        function canUpload(doc : any, userRights ?: any) {
            return  (getOwnerId(doc) === getUserId()) || (userRights && userRights.contains(permissions.CONTRIBUTE));
        }

        function canEditWithO365(doc : DocMetadata, userRights ?: any){
            // Editing is not supported in the Recycle Bin.
            if (fileManager.isInTrash()) {
                return false;
            }


            // User should be allowed to edit a document in O365 only if they have download permissions
            // to a document and are either an owner and contributor for the said document
            if(!canDownload(doc, userRights) || !$rootScope.office365EditingEnabled){
                return false;
            }

            // if it is an office file and the user is either owner or contributor they can edit the file.
            return  $scope.isOfficeFile(doc) && (getOwnerId(doc) === getUserId() || (userRights && userRights.contains(permissions.CONTRIBUTE))) &&
                !$scope.isOfficeLegacyFile(doc) && (!doc.CheckoutInfo || $scope.isDocumentCheckedOutByO365(doc));
        }

        function canShare(docOrFolder: any, resourceType: any, userRights ?: any) {
            // Sharing is not supported in the Recycle Bin.
            if (fileManager.isInTrash()) {
                return false;
            }

            // Only owners and coowners can share documents/folders.
            if (docOrFolder && getOwnerId(docOrFolder) === getUserId() || (userRights && userRights.contains(permissions.SHARE))) {
                return true;
            }
            return false;
        }

        function canShareLink(docOrFolder: any, resourceType: any, userRights ?: any) {
            // Sharing link is not supported in the Recycle Bin.
            if (fileManager.isInTrash()) {
                return false;
            }

            // Only owners and coowners can share anonymously documents.
            if (docOrFolder && getOwnerId(docOrFolder) === getUserId() || (userRights && userRights.contains(permissions.SHARE))) {
                return $scope.isAnonymousSharingEnabled;
            }
            return false;
        }

        function canRename(docOrFolder : any, userRights ?: any) {
            // Currently, users do not have rename permission inside of the "Shared with me" root folder.
            // Renaming is not supported in the recycle bin.
            if (fileManager.isInTrash()) {
                return false;
            }

            // Only owners or contributers can rename documents or folders
            if (docOrFolder && getOwnerId(docOrFolder) === getUserId()) {
                return true;
            } else {
                return userRights && userRights.contains(permissions.RENAME);
            }
        }

        function canRemoveFromShare(docOrFolder, userRights) {
            // Remove From Share should not be available outside of "Shared with me"
            // (It also doesn't make sense to put it in subfolders/documents, since we are not directly sharing those)
            if (!$scope.inShared()) {
                return false;
            }

            // Non-owners can remove from share UNLESS the file is shared with org.
            return docOrFolder && userRights.contains(permissions.REMOVE_FORM_SHARE);
        }

        function canMove(docOrFolder : any, userRights ?: any) {
            // Move is not supported in the Recycle Bin and 'share with me' root view.
            if (fileManager.isInTrash() || $scope.inShared()) {
                return false;
            }

            // Only owners can move documents or folders
            if (docOrFolder && getOwnerId(docOrFolder) === getUserId()) {
                return true;
            } else {
                return userRights && userRights.contains(permissions.MOVE);
            }
        }

        /**
         * This method should check how many files are selected an enable/disable actionBar options
         */
        function updateTopActionBar() {
            var selectedResources = (fileManager.selectedFolders() || []).concat(fileManager.selectedFiles() || []);

            //We support only one bulk action, Delete.
            var canBulkDelete = true,
                resourceId;
            $scope.actionBar = {
                showMoreOptions : false,
                canOpenContainingFolder: (View === viewTypes.FAVORITES),
                canEdit : false,
                canEditOnline : false,
                canOpen: true,
                canCheckout : false,
                canDiscardCheckout : false,
                canCheckin : false,

                canShare : false,
                canShareLink : false,
                canDelete : false,
                canMove : false,
                canDownload : false,
                canUpload: false,
                canRequestCheckin : false,
                canRename : false,
                canRemoveFromShare : false
            };
            if (selectedResources.length <= 0) {
                return;
            }
            if (selectedResources.length > 1) {
                selectedResources.forEach(function(resourceId) {
                    canBulkDelete = canBulkDelete && $scope.userActionsMap[resourceId].canDelete;
                });
                $scope.actionBar.canDelete = canBulkDelete;
                return;
            } else {
                resourceId = selectedResources[0];
                $scope.actionBar.canEdit = $scope.userActionsMap[resourceId].canEdit;
                $scope.actionBar.canEditOnline = $scope.userActionsMap[resourceId].canEditOnline;

                //CIN/COUT actions
                $scope.actionBar.canCheckout = $scope.userActionsMap[resourceId].canCheckout;
                $scope.actionBar.canDiscardCheckout = $scope.userActionsMap[resourceId].canDiscardCheckout;
                $scope.actionBar.canCheckin = $scope.userActionsMap[resourceId].canCheckin;

                $scope.actionBar.canShare = $scope.userActionsMap[resourceId].canShare;
                $scope.actionBar.canShareLink = $scope.userActionsMap[resourceId].canShareLink;
                $scope.actionBar.canDelete = $scope.userActionsMap[resourceId].canDelete;
                $scope.actionBar.canMove = $scope.userActionsMap[resourceId].canMove;
                $scope.actionBar.canDownload = $scope.userActionsMap[resourceId].canDownload;
                $scope.actionBar.canUpload = $scope.userActionsMap[resourceId].canUpload;
                $scope.actionBar.canRequestCheckin = $scope.userActionsMap[resourceId].canRequestCheckin;
                $scope.actionBar.canRename = $scope.userActionsMap[resourceId].canRename;
                $scope.actionBar.canRemoveFromShare = $scope.userActionsMap[resourceId].canRemoveFromShare;
                $scope.actionBar.canEditWithO365 = $scope.userActionsMap[resourceId].canEditWithO365;
                $scope.actionBar.isOfficeLegacyFile = $scope.userActionsMap[resourceId].isOfficeLegacyFile;
            }
        }

        function isFolder(resource) {
            return !isDocument(resource);
        }

        function isDocument(resource) {
            return resource.VersionMetadata;
        }

        var DOM_WRITE_BATCH_SIZE = 20;

        //Always maintain the timeout promise in this closure scope, so that you can cancel any pending promises upon $scope destruction.
        //This will improve performance by not running $digest() for the subsequent $timeout calls
        var addDocsFoldersToViewModelTimeoutPromise = null;
        $scope.$on("$destroy", function() {
            if (addDocsFoldersToViewModelTimeoutPromise) {
                $timeout.cancel(addDocsFoldersToViewModelTimeoutPromise);
            }
        });

        function renderDocsAndFoldersInChunks(chunks) {
            var length = chunks.length,
                currentChunkIdx = 0,
                deferred = $q.defer(),
                startTime;

            var atfLatencyEvent = $rootScope.metricServiceInstance.newAnonymousLatencyMetric();
            var fullLatencyEvent = $rootScope.metricServiceInstance.newAnonymousLatencyMetric();
            addDocsFoldersToViewModel();

            //Emitting two metrics to comparision
            setTimeout(function() {
                atfLatencyEvent.emitMetricWithMethodName("FileBrowser." + View + ".ATF_RENDER_COMPLETE_NEXT_TICK");
            });
            $scope.registerPostDigestCallback(function() {
                atfLatencyEvent.emitMetricWithMethodName("FileBrowser." + View + ".ATF_RENDER_COMPLETE");
            });

            return deferred.promise;
            function addDocsFoldersToViewModel() {
                //After the $timeout calls this method, reset the "addDocsFoldersToViewModelTimeoutPromise" to null
                addDocsFoldersToViewModelTimeoutPromise = null;

                var chunk = chunks[currentChunkIdx++];
                $scope.folders = $scope.folders.concat(chunk.filter(isFolder));
                $scope.documents = $scope.documents.concat(chunk.filter(isDocument));
                if (currentChunkIdx < length) {
                    addDocsFoldersToViewModelTimeoutPromise = $timeout(addDocsFoldersToViewModel, 0);
                } else {
                    deferred.resolve('done');

                    //Emitting two metrics to comparision
                    setTimeout(function() {
                        fullLatencyEvent.emitMetricWithMethodName("FileBrowser." + View + ".FULL_RENDER_COMPLETE_NEXT_TICK");
                    });
                    $scope.registerPostDigestCallback(function(){
                         fullLatencyEvent.emitMetricWithMethodName("FileBrowser." + View + ".FULL_RENDER_COMPLETE");
                    });
                }
            }
        }

        //Used for synchronizing the sorts or UI rendering during browser interactions
        var pendingRenderPromise;
        $scope.setDocumentsAndFolders = setDocumentsAndFolders;
        /**
         * This function sets the documents and folders from FileManager service
         * into this view model.
         *
         * @param writeInBatches Specifies if the writes to DOM should be chunked for performance (use it if doing full folder load/sorting)
         */
        function setDocumentsAndFolders(writeInBatches ?: boolean) {
            if (pendingRenderPromise) {
                return pendingRenderPromise.then(function(dataIn) {
                    setDocumentsAndFolders(writeInBatches);
                    return dataIn;
                });
            }
            var folders = fileManager.getFolders() || [];
            var documents = fileManager.getFiles() || [];
            var promise;
            if (writeInBatches && folders.length + documents.length > 2 * DOM_WRITE_BATCH_SIZE) {
                $scope.folders = [];
                $scope.documents = [];
                promise = renderDocsAndFoldersInChunks((_ as any).chunkArray([].concat(folders).concat(documents), DOM_WRITE_BATCH_SIZE));
            } else {
                $scope.folders = folders;
                $scope.documents = documents;

                var atfLatencyEvent = $rootScope.metricServiceInstance.newAnonymousLatencyMetric();

                //emitting two metrics for comparision
                $scope.registerPostDigestCallback(function() {
                    atfLatencyEvent.emitMetricWithMethodName("FileBrowser." + View + ".ATF_RENDER_COMPLETE");
                });
                setTimeout(function() {
                    atfLatencyEvent.emitMetricWithMethodName("FileBrowser." + View + ".ATF_RENDER_COMPLETE_NEXT_TICK");
                });

                promise = $q.when('done');
            }

            if (!$scope.folderState.loaded) {
                $scope.folderState.loaded = true;

                // After the scope.folders & documents are set, the user will be able to view the list view.
                ClientMetricsService.recordPageVisible();
                if($rootScope.allTabsLatencyMetric){
                    $rootScope.allTabsLatencyMetric.stopAndEmitMetric();
                    delete $rootScope.allTabsLatencyMetric;
                }
                if($rootScope.sharedEntryPathMetric){
                    const LatencyMetricEntry = $rootScope.LatencyMetricEntry;
                    const sharedDataLoadMetric = new LatencyMetricEntry("Shared_Tab_Refresh_Load");
                    sharedDataLoadMetric.Values = performance.now();
                    $rootScope.metricServiceInstance.putMetric(sharedDataLoadMetric);
                    delete $rootScope.sharedEntryPathMetric;
                }
                if($rootScope.sharedTabLatencyMetric){
                    $rootScope.sharedTabLatencyMetric.stopAndEmitMetric();
                    delete $rootScope.sharedTabLatencyMetric;
                }
            }
            pendingRenderPromise = promise;
            return promise.then(function(dataIn) {
                pendingRenderPromise = null;
                $timeout(function() {
                    // Cannot remove from here because setDocumentsAndFolders is called by different functions
                    // which are all changes current file list in different ways. Here is a more general place
                    // to emit this event than any of its caller.
                    $rootScope.$broadcast(SignalProvider.ContentLoading.Done);
                } as any, false);
                return dataIn;
            });
        }

        function checkForOfficeUnlockSignal(Documents) {
            if (!Documents) {
                return;
            }
            var docsWaitingOnUnlock = Documents.filter(function(doc) {
                return doc.CheckoutInfo && doc.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.APP;
            });
            if (docsWaitingOnUnlock.length) {
                kickOffTimerForUnlockCheck(docsWaitingOnUnlock);
            }
        }

        function kickOffTimerForUnlockCheck(docsWaitingOnUnlock) {
            docsWaitingOnUnlock.forEach(function(doc) {
                var timeoutVal,
                    docId = doc.Id,
                    startTime = Date.now(),
                    currentBackoffVal = 1;

                $scope.$on("$destroy", function() {
                    if (timeoutVal) {
                        $timeout.cancel(timeoutVal);
                    }
                });

                function rescheduleTheCall() {
                    //Only reschedule until a certain time. After that set a flag on the document that wopi unlock failed
                    if ((Date.now() - startTime) > (AppConstants.O365.MAX_TIME_LIMIT_IN_WAITING_FOR_UNLOCK_IN_SEC * 1000)) {
                        //Set a flag in the view model when the unlock is complete
                        doc.appUnlockStatus = AppConstants.APP_UNLOCK_STATUS.TIMEOUT;
                        return;
                    }
                    currentBackoffVal = Math.min(currentBackoffVal * 2, AppConstants.O365.MAX_TIME_LIMIT_IN_RETRYING_FOR_UNLOCK_IN_SEC);
                    timeoutVal = $timeout(checkForUnlockSignal, currentBackoffVal * 1000);
                    if (currentBackoffVal === 1) {
                        currentBackoffVal = 2;
                    }
                }

                function checkForUnlockSignal() {
                    timeoutVal = null;
                    //make getDocument call to determine if the unlock is done
                    DocumentService.getDocument(docId, true)
                        .then(function getDocumentSuccessCallback(response) {
                            var data = response.data;
                            if (data && data.Metadata) {
                                var Metadata = data.Metadata;
                                if (!Metadata.CheckoutInfo) {
                                    //Set a flag in the view model when the unlock is complete
                                    doc.appUnlockStatus = AppConstants.APP_UNLOCK_STATUS.COMPLETE;
                                    doc.CheckoutInfo = null;
                                } else if (Metadata.CheckoutInfo.LockType === AppConstants.LOCK_TYPES.APP) {
                                    //If the document is still not unlocked and it contains a Reason field then retry the call
                                    rescheduleTheCall();
                                }
                            } else {
                                rescheduleTheCall();
                            }
                        }, rescheduleTheCall);

                }
                checkForUnlockSignal();
                doc.appUnlockStatus = AppConstants.APP_UNLOCK_STATUS.PENDING;
            });
        }

        var missingResourcesModal;
        $scope.removeMissingResources = function() {
            var contentTypes = AppConstants.FolderContentTypes;
            if (!$scope.missingResources) {
                return;
            }
            if ($scope.missingResources.Folders) {
                $scope.missingResources.Folders.forEach(function(Id) {
                    $log.debug('Deleting favorite folder with ID ' + Id);
                    FavoritesService.deleteFav(Id, contentTypes.FOLDER);
                });
            }
            if($scope.missingResources.Documents) {
                $scope.missingResources.Documents.forEach(function(Id) {
                    $log.debug('Deleting favorite document with ID ' + Id);
                    FavoritesService.deleteFav(Id, contentTypes.DOCUMENT);
                });
            }
        };
        $scope.closeMissingResourcesModal = function() {
            if (missingResourcesModal) {
                missingResourcesModal.close();
                missingResourcesModal = null;
            }
        };
        $scope.showMissingResourcesModal = function($event) {
            //Close an existing modal if there exists one
            $scope.closeMissingResourcesModal();
            missingResourcesModal = $uibModal.open({
                templateUrl: './file-browser/missingResourcesModal.html',
                size: 'lg',
                windowClass : 'missing-resources-modal-window',
                scope : $scope
            });
            missingResourcesModal.result.then(null, function() {
                $scope.clearAllMessages();
            })
            .finally(function() {
                missingResourcesModal = null;
            });
        };

        $scope.highlightResourceIfNecessary = function() {
            var docsHasIt,
                foldersHasIt;
            if ($routeParams.highlightResourceId) {
                //Check if the $scope.documents or $scope.folders have that resource, if not fetch all pages and then highlight it
                docsHasIt = $scope.documents.some(function(doc) {
                    return doc.Id === $routeParams.highlightResourceId;
                });
                if (!docsHasIt) {
                    foldersHasIt = $scope.folders.some(function(folder) {
                        return folder.Id === $routeParams.highlightResourceId;
                    });
                }
                if (docsHasIt || foldersHasIt) {
                    $scope.$broadcast(SignalProvider.Folder.HighlightResource, $routeParams.highlightResourceId);
                } else {
                    $scope.loadMore(true).then(function() {
                        $scope.$broadcast(SignalProvider.Folder.HighlightResource, $routeParams.highlightResourceId);
                    });
                }
            }
        };

        function syncView(sortBy, order, noUpdateFlag: boolean) {
            var loadFolderPromise, renderFolderPromise;

            PathManager.clearPath();
            // update file count shown in left navigation menu.
            FileCountService.signal();

            // set layout of current view.
            LayoutManager.is($scope.folderState.view, $scope, $scope.folderState.view === viewTypes.FOLDER_TYPE ? fileManager.getCurrentFolder() : null);
            ClientMetricsService.startLatencyEvent(MetricEvents[View + "_API_CALL_LATENCY"]);
            if ($scope.folderState.view === viewTypes.SHARED_TYPE) {
                fileManager.loadTaggedContentImpl(SystemTags.SHARED_WITH_ME, null, true).then(syncViewRenderCachedData, errorCallback);
            } else if ($scope.folderState.view === viewTypes.SHARED_BY_ME_TYPE){
            	$scope.folderState.loaded = false;
            	fileManager.loadSharedByMeContentImpl($scope.currentSharedByMeFilter, null).then(syncViewRenderCachedData, errorCallback);
            } else {
                loadFolderPromise = fileManager.loadCurrentFolder().then(successCallback, errorCallback);
                // load current folder content.
                PromiseWatcherService.add(loadFolderPromise, MetricEvents.APP_LOAD_SERVICE_COMPLETE_EVENT);
            }

            function syncViewRenderCachedData(folderResult) {
            	 // ajax call to serrvice has completed.
                ClientMetricsService.stopAndRecordLatencyEvent(MetricEvents[View + "_API_CALL_LATENCY"]);
                ClientMetricsService.startLatencyEvent(MetricEvents[View + "_RENDER_COMPLETE_LATENCY"]);

                updateUsers(fileManager.getFiles(), fileManager.getFolders());
                // apply favorites
                $scope.applyFavorites(fileManager.getFiles(), fileManager.getFolders(), Favorites, true);

                renderFolderPromise = setDocumentsAndFolders(true);
                renderFolderPromise.then($scope.highlightResourceIfNecessary);
                loadFolderPromise = fileManager.loadCurrentFolder();
                loadFolderPromise = $q.all({
                    renderResult : renderFolderPromise,
                    serverResult : loadFolderPromise
                }).then(function(result) {
                    //rendering complete and server fetch
                    successCallback(result.serverResult);
                }, errorCallback);

                PromiseWatcherService.add(loadFolderPromise, MetricEvents.APP_LOAD_SERVICE_COMPLETE_EVENT);
                ClientMetricsService.recordAppLoad();
            }

            function successCallback(folderResult) {

				//Check if any documents are checked out by WOPI server
				checkForOfficeUnlockSignal(fileManager.getFiles() || []);

                if (!noUpdateFlag) {
                    if ($scope.folderState.view === viewTypes.SHARED_TYPE) {
                        updateUsers(fileManager.getFiles(), fileManager.getFolders());
                    }
                    $scope.getCheckoutUsersInfo(fileManager.getFiles());

                    if ($scope.folderState.view !== viewTypes.FAVORITES) {
                        $scope.applyFavorites(fileManager.getFiles(), fileManager.getFolders(), Favorites);
                    } else {
                        $scope.missingResources = fileManager.getMissingDocsAndFoldersFromFavorites();
                        if ($scope.missingResources.Folders.length && $scope.missingResources.Documents.length) {
                            MessageManager.addInfoMessage($translate.instant('FAVORITES.MISSING_DOCS_AND_FOLDERS_FROM_FAVORITES_LIST'), true)
                            .then($scope.showMissingResourcesModal.bind($scope));
                        } else if ($scope.missingResources.Folders.length) {
                            MessageManager.addInfoMessage($translate.instant('FAVORITES.MISSING_FOLDERS_FROM_FAVORITES_LIST'), true)
                            .then($scope.showMissingResourcesModal.bind($scope));
                        } else if ($scope.missingResources.Documents.length) {
                            MessageManager.addInfoMessage($translate.instant('FAVORITES.MISSING_DOCS_FROM_FAVORITES_LIST'), true)
                            .then($scope.showMissingResourcesModal.bind($scope));
                        }
                        $scope.removeMissingResources();
                    }

                    if ($scope.folderState.view === viewTypes.SHARED_TYPE) {
                        //Do not render in chunks for Shared With Me, because the first one would have rendered in chunks. After that rendering, this will be fast as rarely new DOM nodes
                        //are created.
                        setDocumentsAndFolders(false);
                    } else {
                        setDocumentsAndFolders(true).then($scope.highlightResourceIfNecessary);
                    }

                }

                if (folderResult && folderResult.folder) {
                    if ($scope.inOwn() || ($scope.folderState.view === viewTypes.FOLDER_TYPE && !$scope.inRecycle())) {
                        processFolderInfo(folderResult.folder);

                        // Cache the documents we already have when coming from the list view so the prev/next document feature can use them.
                        GetNextDocumentService.setDocsExclusively(fileManager.getFiles(), $scope.folderState.activeFolderId);
                        GetNextDocumentService.setMarker(fileManager.getMarker(), $scope.folderState.activeFolderId);
                    }
                }

                if ($scope.folderState.view !== viewTypes.SHARED_TYPE) {
                    ClientMetricsService.recordAppLoad();
                    ClientMetricsService.stopAndRecordLatencyEvent(MetricEvents[View + "_API_CALL_LATENCY"] );
                    ClientMetricsService.startLatencyEvent(MetricEvents[View + "_RENDER_COMPLETE_LATENCY"]);

                    // Schedule an event to record render latency.
                    $timeout(function() {
                        //record complete event
                        ClientMetricsService.stopAndRecordLatencyEvent(MetricEvents[View + "_RENDER_COMPLETE_LATENCY"]);
                        ClientMetricsService.recordPageLoad();
                    }, 0, false);
                    // $scope.onlineEditingDocumentId is set when a document is created and ready to be opened in the online editor. This if block will only be executed in this scenario and not anywhere else.
                    if($scope.onlineEditingDocumentId) {
                        $location.url('/document/' + $scope.onlineEditingDocumentId+ '?editOnline=true');
                        $scope.onlineEditingDocumentId=null;
                        $scope.folderState.loaded = true;
                    }
                }

                $rootScope.$broadcast(SignalProvider.Selection.SelectionUpdated);

                var getOrganizationPromise = OrganizationService.getOrganization();
                getOrganizationPromise.then(function(result){
                    $scope.data = angular.fromJson(result);
                    // Emit log and metric
                    AppConstants.ORG_WIDE_SHARING_SCOPE = $scope.data.data.Organization.OrgWideSharingScope;
                    $log.info('syncView succeeded in view: ' + $scope.layout.view);
                    $rootScope.metricServiceInstance.newCounterMetric('FileBrowser.syncView.' + $scope.layout.view + '.succeeded');
                });
                
            }

            function errorCallback(err) {
                $scope.layout.hasRightSidebar = false;
                $scope.layout.showLeftSidebar = true;
                $scope.folderState.folderErrorCode = err.result ? err.result.status : err.status;

                if ($routeParams.fromSearch === 'true') {
                    $location.path('/shared').replace();
                }

                document.title = AppConstants.APP_NAME;

                // Emit log and metric
                $log.error('syncView failed in view: ' + $scope.layout.view);
                $log.error('syncView failed with error: ' + JSON.stringify(err));
                $rootScope.metricServiceInstance.newCounterMetric('FileBrowser.syncView.' + $scope.layout.view + '.failed');
            }
        }

        function processFolderInfo(folderInfo) {
            $scope.metadata = folderInfo.Metadata;
            $scope.folderState.activeParentFolderId = $scope.metadata.ParentFolderId;
            $scope.folderState.activeFolderOwnerUsername = $scope.metadata.Owner.Username;
            $scope.folderState.principals = fileManager.getCurrentFolderPrincipals();
            $scope.layout.showUploadPane = fileManager.hasRightForFolder(permissions.UPLOAD) && !fileManager.isInTrash();

            if (!fileManager.hasRightForFolder(permissions.CONTRIBUTE)) {
                $scope.sidebar.tabs = ['People'];
            }

            if (fileManager.hasRightForFolder(permissions.UPLOAD)) {
                if ($scope.fileManagerInstance.isInTrash()) {
                    $scope.folderState.emptyMessage = MessageProvider.emptyMessageDocsListViewOnly;
                } else {
                    $scope.folderState.emptyMessage = MessageProvider.emptyMessageDocsList;
                }
            }

            if (!$scope.inOwn()) {
                $scope.pageTitle = $scope.metadata.Name;
                document.title = $scope.pageTitle + ' - ' + AppConstants.APP_NAME;
            }

            PathManager.setUploadFolderId(fileManager.getCurrentFolder());
            FileService.getFolderPath($scope.metadata.Id)
            .then(function success (response) {
                var data = response.data;
                var rootFolderId = data.Path.Components[0].Id;
                if (rootFolderId === userInfo.RootFolderId) {
                    $scope.folderState.inOwnFolder = true;
                } else if (rootFolderId === userInfo.RecycleBinFolderId) {
                    $scope.folderState.inRecycle = true;
                } else {
                    $scope.folderState.deepInSharedFolder = true;
                }
                PathManager.setPath(data.Path , userInfo);
                $scope.path = data.Path.Components;
            }, function error () {
                $scope.path = [{
                    Id: $scope.metadata.Id,
                    Name: $scope.metadata.Name
                }];
            });
        }

        function closeModalOnScopeIsDestroied(uibModal) {
            $scope.$on("$destroy", function() {
                if (uibModal) {
                    uibModal.close();
                }
            });
        }

        function updateNumberSelectedItems() {
            var totalSelected = Object.keys($scope.selectedDocuments);
            totalSelected = totalSelected.concat(Object.keys($scope.selectedFolders));
            $scope.folderState.itemsSelectedCount = (totalSelected.length) ? totalSelected.length : 0;
        }

        function getOwnerId(docOrFolder) {
            // The resource collection v2 provides a list of documents and folders, each of which contains OwnerId but no Owner metadata.
            // The v1 has an Owner metadata but null OwnerId.
            return docOrFolder.OwnerId || (docOrFolder.Owner && docOrFolder.Owner.Id) || docOrFolder.CreatorId;
        }

        function getUserId() {
            return userInfo.Id;
        }

        // Get users for folders and documents.
        function updateUsers(documents, folders) {
            var userIds,
                allResources;

            if (!angular.isArray(documents) && !angular.isArray(folders)) {
                return;
            }

            //For safety, convert these to arrays if not already arrays
            documents = documents || [];
            folders = folders || [];
            allResources = documents.concat(folders);
            userIds = allResources.map(function(docOrFolder) {
                return getOwnerId(docOrFolder);
            });
            userIds = _.uniq(userIds);
            if (userIds.length) {
                UserCollectionService.getUserCollection(userIds).then(function(Users) {
                    var UserMap = {};
                    Users.forEach(function(User) {
                        UserMap[User.Id] = User;
                    });
                    allResources.forEach(function(docOrFolder) {
                        var ownerId = getOwnerId(docOrFolder);
                        docOrFolder.Owner = UserMap[ownerId];
                    });
                });
            }
        }
    }
